import { jsx as n, jsxs as h, Fragment as j } from "react/jsx-runtime";
import V, { useState as P, useEffect as Q, forwardRef as Ge, createElement as He, useRef as q, useMemo as ae, useCallback as se, useLayoutEffect as vo } from "react";
import { useQueryClient as $t, useQuery as wo } from "@tanstack/react-query";
import ge from "react-dom";
const re = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken"
}, So = (e, t, o) => {
  try {
    e ? localStorage.setItem(re.THEME_ID, e) : localStorage.removeItem(re.THEME_ID), localStorage.setItem(re.EDIT_MODE, String(t)), o ? localStorage.setItem(re.EDIT_THEME_TOKEN, o) : localStorage.removeItem(re.EDIT_THEME_TOKEN);
  } catch (a) {
    console.error("Failed to save theme params to localStorage:", a);
  }
}, Bo = () => {
  try {
    return {
      themeId: localStorage.getItem(re.THEME_ID),
      editMode: localStorage.getItem(re.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(re.EDIT_THEME_TOKEN)
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null
    };
  }
}, Fo = () => {
  try {
    localStorage.removeItem(re.THEME_ID), localStorage.removeItem(re.EDIT_MODE), localStorage.removeItem(re.EDIT_THEME_TOKEN);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, Eo = () => {
  try {
    const e = new URLSearchParams(window.location.search), t = e.get("themeId"), o = e.get("editMode") === "true", a = e.get("editThemeToken");
    t && So(t, o, a);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, zo = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, tr = (e, t, o) => {
  try {
    const a = new URL(window.location.href);
    e ? (a.searchParams.set("themeId", e), a.searchParams.set("editMode", String(t)), o ? a.searchParams.set("editThemeToken", o) : a.searchParams.delete("editThemeToken")) : (a.searchParams.delete("themeId"), a.searchParams.delete("editMode"), a.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", a.toString());
  } catch (a) {
    console.error("Failed to update URL params:", a);
  }
}, qe = () => {
  const e = new URLSearchParams(window.location.search), t = e.get("themeId"), o = e.get("editMode"), a = e.get("editThemeToken"), r = e.get("origin"), l = Bo();
  return {
    themeId: t || l.themeId,
    editMode: o === "true" || o === null && l.editMode,
    editThemeToken: a || l.editThemeToken,
    origin: r
  };
}, xe = () => {
  const [e, t] = P(qe);
  return Q(() => {
    const o = setTimeout(() => {
      const a = qe();
      t((r) => r.themeId !== a.themeId || r.editMode !== a.editMode || r.editThemeToken !== a.editThemeToken || r.origin !== a.origin ? a : r);
    }, 0);
    return () => clearTimeout(o);
  }, []), e;
}, i = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, To = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, Io = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, Po = (e, t, o) => {
  switch (e) {
    case "primary":
      return {
        background: o ? i.blue_dark : t ? `linear-gradient(135deg, ${i.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${i.blue_dark} 0%, #1f2463 100%)`,
        color: i.white,
        border: "none",
        boxShadow: t ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: o ? i.gray_border : i.gray_light,
        color: i.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: o ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : t ? `linear-gradient(135deg, ${i.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${i.red} 0%, #e63e37 100%)`,
        color: i.white,
        border: "none",
        boxShadow: t ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: o ? "rgba(0, 0, 0, 0.08)" : t ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: i.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: o ? i.blue_light : t ? "rgba(24, 29, 86, 0.04)" : i.white,
        color: i.blue_dark,
        border: `2px solid ${i.blue_dark}`,
        boxShadow: "none",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: o ? "rgba(0, 0, 0, 0.1)" : t ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: i.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, J = Ge(
  ({
    variant: e = "primary",
    size: t = "md",
    leftIcon: o,
    rightIcon: a,
    isLoading: r = !1,
    pill: l = !1,
    disabled: c,
    children: s,
    style: d,
    ...m
  }, g) => {
    const [y, b] = P(!1), [u, S] = P(!1), p = c || r, k = e === "icon" ? Io[t] : To[t], v = l ? "200px" : k.borderRadius, z = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: p ? "not-allowed" : "pointer",
      opacity: p ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...k,
      borderRadius: v,
      ...Po(
        e,
        !p && y,
        !p && u
      ),
      ...d
    };
    return /* @__PURE__ */ n(
      "button",
      {
        ref: g,
        disabled: p,
        style: z,
        onMouseEnter: () => b(!0),
        onMouseLeave: () => {
          b(!1), S(!1);
        },
        onMouseDown: () => S(!0),
        onMouseUp: () => S(!1),
        ...m,
        children: r ? /* @__PURE__ */ n(Ao, { size: t }) : /* @__PURE__ */ h(j, { children: [
          o && /* @__PURE__ */ n(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: o
            }
          ),
          s,
          a && /* @__PURE__ */ n(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: a
            }
          )
        ] })
      }
    );
  }
);
J.displayName = "Button";
const Ao = ({ size: e }) => {
  const t = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ h(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ n("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ n(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mo = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), No = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, o, a) => a ? a.toUpperCase() : o.toLowerCase()
), Ve = (e) => {
  const t = No(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, qt = (...e) => e.filter((t, o, a) => !!t && t.trim() !== "" && a.indexOf(t) === o).join(" ").trim(), Ho = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Oo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Do = Ge(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: o = 2,
    absoluteStrokeWidth: a,
    className: r = "",
    children: l,
    iconNode: c,
    ...s
  }, d) => He(
    "svg",
    {
      ref: d,
      ...Oo,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: a ? Number(o) * 24 / Number(t) : o,
      className: qt("lucide", r),
      ...!l && !Ho(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...c.map(([m, g]) => He(m, g)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ee = (e, t) => {
  const o = Ge(
    ({ className: a, ...r }, l) => He(Do, {
      ref: l,
      iconNode: t,
      className: qt(
        `lucide-${Mo(Ve(e))}`,
        `lucide-${e}`,
        a
      ),
      ...r
    })
  );
  return o.displayName = Ve(e), o;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ro = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ee = ee("check", Ro);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jo = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Je = ee("chevron-right", jo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wo = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], Lo = ee("circle-check-big", Wo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qo = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Go = ee("circle-x", Qo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jo = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Yo = ee("loader", Jo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xo = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], Ke = ee("log-out", Xo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zo = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], Uo = ee("monitor", Zo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $o = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], _e = ee("palette", $o);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qo = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], Vt = ee("pencil", qo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vo = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Ye = ee("plus", Vo);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ko = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], _o = ee("rotate-ccw", Ko);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ea = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], Kt = ee("search", ea);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ta = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], et = ee("settings", ta);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oa = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], aa = ee("smartphone", oa);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const na = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], _t = ee("upload", na);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ra = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], de = ee("x", ra);
function ia() {
  const e = Array.from(
    document.getElementsByTagName("script")
  ).filter((r) => r.hasAttribute("data-api-domain"));
  if (e.length > 0)
    return e[e.length - 1];
  if (document.currentScript)
    return document.currentScript;
  const t = Array.from(document.getElementsByTagName("script")), o = t.find((r) => {
    const l = r.src;
    return l && l.includes("bc-widgets");
  });
  if (o)
    return o;
  const a = t.find((r) => {
    const l = r.src;
    return l && (l.includes("bc-checkout-shop-app") || l.includes("brandclub-checkout-shop-app"));
  });
  return a || (t.length > 0 ? t[t.length - 1] : null);
}
const eo = (() => {
  const e = ia();
  if (e != null && e.hasAttribute("data-api-domain")) {
    const o = e.getAttribute("data-api-domain");
    if (o)
      return o.startsWith("http://") || o.startsWith("https://") ? o : `https://${o}`;
  }
  const t = e == null ? void 0 : e.src;
  if (t)
    try {
      return `https://${new URL(t).hostname}`;
    } catch {
    }
  return typeof window < "u" ? (console.warn(
    "[bc-widgets] Could not determine script domain, using window.location.origin as fallback. Consider adding data-api-domain attribute to script tag."
  ), window.location.origin) : "";
})(), ie = `${eo}/api-rewards`;
eo.replace(/^https?:\/\//, "");
const la = async (e) => {
  const t = await fetch(
    `${ie}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch widget theme");
  return t.json();
}, sa = async (e) => {
  const t = await fetch(
    `${ie}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch published widget theme");
  return t.json();
}, ca = async ({
  themeId: e,
  widgetId: t,
  widgetState: o,
  editThemeToken: a
}) => {
  const r = await fetch(
    `${ie}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: t,
        widgetState: o,
        editThemeToken: a
      })
    }
  );
  if (!r.ok) {
    let l = "Failed to update widget config";
    try {
      l = (await r.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return r.json();
}, tt = async ({
  themeId: e,
  colorKey: t,
  colorValue: o,
  editThemeToken: a
}) => {
  const r = await fetch(
    `${ie}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        colorValue: o,
        editThemeToken: a
      })
    }
  );
  if (!r.ok) {
    let l = "Failed to set theme color";
    try {
      l = (await r.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return r.json();
}, da = async ({
  themeId: e,
  colorKey: t,
  editThemeToken: o
}) => {
  const a = await fetch(
    `${ie}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        editThemeToken: o
      })
    }
  );
  if (!a.ok) {
    let r = "Failed to delete theme color";
    try {
      r = (await a.json()).message || r;
    } catch {
    }
    throw new Error(r);
  }
  return a.json();
}, pa = async ({
  themeId: e,
  oldColorKey: t,
  newColorKey: o,
  editThemeToken: a
}) => {
  const r = await fetch(
    `${ie}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: t,
        newColorKey: o,
        editThemeToken: a
      })
    }
  );
  if (!r.ok) {
    let l = "Failed to rename theme color";
    try {
      l = (await r.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return r.json();
}, ot = async ({
  themeId: e,
  fileName: t,
  contentType: o,
  assetType: a,
  editThemeToken: r
}) => {
  const l = await fetch(
    `${ie}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: t,
        contentType: o,
        assetType: a,
        editThemeToken: r
      })
    }
  );
  if (!l.ok) {
    let s = "Failed to generate upload URL";
    try {
      const d = await l.json();
      s = d.errorMessage || d.message || s;
    } catch {
    }
    throw new Error(s);
  }
  const c = await l.json();
  if (c.status === "failed")
    throw new Error(c.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: c.signedUploadUrl,
    objectPublicUrl: c.objectPublicUrl
  };
}, at = async ({
  file: e,
  signedUploadUrl: t
}) => {
  if (!(await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, ma = async ({
  themeId: e,
  fontKey: t,
  fontValue: o,
  editThemeToken: a
}) => {
  const r = await fetch(
    `${ie}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        fontValue: o,
        editThemeToken: a
      })
    }
  );
  if (!r.ok) {
    let l = "Failed to set theme font";
    try {
      l = (await r.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return r.json();
}, ga = async ({
  themeId: e,
  fontKey: t,
  editThemeToken: o
}) => {
  const a = await fetch(
    `${ie}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        editThemeToken: o
      })
    }
  );
  if (!a.ok) {
    let r = "Failed to delete theme font";
    try {
      r = (await a.json()).message || r;
    } catch {
    }
    throw new Error(r);
  }
  return a.json();
}, ua = async ({
  themeId: e,
  iconKey: t,
  iconValue: o,
  editThemeToken: a
}) => {
  const r = await fetch(
    `${ie}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        iconValue: o,
        editThemeToken: a
      })
    }
  );
  if (!r.ok) {
    let l = "Failed to set theme icon";
    try {
      l = (await r.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return r.json();
}, ha = async ({
  themeId: e,
  iconKey: t,
  editThemeToken: o
}) => {
  const a = await fetch(
    `${ie}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        editThemeToken: o
      })
    }
  );
  if (!a.ok) {
    let r = "Failed to delete theme icon";
    try {
      r = (await a.json()).message || r;
    } catch {
    }
    throw new Error(r);
  }
  return a.json();
}, ze = ["bc-widget-theme"], to = "bc-theme-updated";
let Me = null, nt = !1;
const ya = (e) => {
  Me = e, Q(() => {
    if (nt) return;
    nt = !0;
    const t = (o) => {
      var r;
      if (o.origin !== window.location.origin || ((r = o.data) == null ? void 0 : r.type) !== to || !Me) return;
      const { themeId: a } = o.data.payload;
      Me.refetchQueries({
        queryKey: [...ze, a]
      });
    };
    window.addEventListener("message", t);
  }, []);
}, ke = () => {
  const e = xe(), t = $t();
  return ya(t), wo({
    queryKey: [...ze, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return la(e.themeId);
      const o = window.location.hostname;
      return sa(o);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, oo = () => {
  var a;
  const { data: e, isLoading: t, refetch: o } = ke();
  return {
    themeColors: ((a = e == null ? void 0 : e.config) == null ? void 0 : a.colors) || {},
    isLoading: t,
    refreshThemeColors: async () => {
      await o();
    }
  };
}, ao = () => {
  var a;
  const { data: e, isLoading: t, refetch: o } = ke();
  return {
    themeFonts: ((a = e == null ? void 0 : e.config) == null ? void 0 : a.fonts) || {},
    isLoading: t,
    refreshThemeFonts: async () => {
      await o();
    }
  };
}, no = () => {
  var a;
  const { data: e, isLoading: t, refetch: o } = ke();
  return {
    themeIcons: ((a = e == null ? void 0 : e.config) == null ? void 0 : a.icons) || {},
    isLoading: t,
    refreshThemeIcons: async () => {
      await o();
    }
  };
}, ba = (e, t) => {
  var l, c;
  const { data: o, isLoading: a } = ke(), r = e ? (c = (l = o == null ? void 0 : o.config) == null ? void 0 : l.widgetConfig) == null ? void 0 : c[e] : void 0;
  return {
    ...t,
    ...r,
    isLoading: a
  };
}, fa = (e) => {
  const t = $t(), o = xe();
  return { updateWidgetConfig: (l, c) => {
    e && t.setQueryData(
      [...ze, o.themeId],
      (s) => {
        var d, m, g;
        return s ? {
          ...s,
          config: {
            ...s == null ? void 0 : s.config,
            widgetConfig: {
              ...(d = s == null ? void 0 : s.config) == null ? void 0 : d.widgetConfig,
              [e]: {
                ...(g = (m = s == null ? void 0 : s.config) == null ? void 0 : m.widgetConfig) == null ? void 0 : g[e],
                [l]: c
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [l]: c
              }
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var c, s;
    if (!e) return;
    const l = t.getQueryData([
      ...ze,
      o.themeId
    ]);
    return (s = (c = l == null ? void 0 : l.config) == null ? void 0 : c.widgetConfig) == null ? void 0 : s[e];
  } };
}, Ce = 60, rt = 420, it = ({
  showSettings: e,
  viewMode: t,
  editorMode: o = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${Ce}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${i.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${i.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${i.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${i.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${i.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${i.primary};
    background: ${i.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${i.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${i.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${i.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${Ce}px;
    left: 0;
    right: ${e ? rt : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${t === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${t === "desktop" ? "100%" : "375px"};
    height: ${t === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${t === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${Ce}px;
    right: 0;
    bottom: 0;
    width: ${rt}px;
    background: #fff;
    border-left: 1px solid ${i.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${i.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${i.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${i.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${i.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${i.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${i.gray_light};
    color: ${i.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${i.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${i.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${i.white};
    border-radius: 12px;
    border: 1px solid ${i.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${i.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${i.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${i.gray_medium};
    background: ${i.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${i.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${i.overlay_light};
    border-radius: 12px;
    border: 1px solid ${i.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${i.white};
    box-shadow: 0 2px 8px ${i.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${i.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${i.white};
    color: ${i.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${i.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${i.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${i.gray_medium};
    width: 85px;
    text-align: right;
    background: ${i.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${i.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${i.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${i.gray_light};
    color: ${i.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${i.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${i.blue};
    border: 2px dashed ${i.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${i.blue_light};
    border-color: ${i.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${i.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${i.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${i.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${i.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${i.gray_medium};
    background: ${i.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${i.overlay_light};
    border: 1px solid ${i.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${i.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${i.white};
    border-color: ${i.blue};
    color: ${i.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${i.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${i.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${o === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${Ce}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, ro = () => typeof window > "u" ? !1 : window.self !== window.top, Pe = () => {
  var e, t;
  return typeof window > "u" ? document.body : window.self !== window.top && ((t = (e = window.parent) == null ? void 0 : e.document) != null && t.body) ? window.parent.document.body : document.body;
}, Oe = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, xa = async () => {
  if (typeof window > "u") return !0;
  try {
    const t = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(t != null && t.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, ka = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, f = (e) => e.map((t) => ({
  weight: t,
  label: ka[t] || `Weight ${t}`
})), Te = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: f([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: f([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: f([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: f([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: f([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: f([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: f([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: f([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: f([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: f([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: f([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: f([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: f([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: f([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: f([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: f([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: f([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: f([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: f([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: f([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: f([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: f([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: f([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: f([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: f([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: f([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: f([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: f([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: f([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: f([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: f([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: f([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: f([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: f([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: f([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: f([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: f([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: f([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: f([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: f([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: f([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: f([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: f([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: f([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: f([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: f([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: f([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: f([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: f([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: f([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: f([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: f([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: f([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: f([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: f([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: f([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: f([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: f([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: f([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: f([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: f([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: f([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: f([400, 500, 700])
  }
], Ca = (e, t = [500]) => {
  const o = e.replace(/ /g, "+"), a = t.join(";");
  return `https://fonts.googleapis.com/css2?family=${o}:wght@${a}&display=swap`;
}, va = (e) => `https://fonts.googleapis.com/css2?${e.map((o) => {
  const a = o.name.replace(/ /g, "+"), r = o.weights.join(";");
  return `family=${a}:wght@${r}`;
}).join("&")}&display=swap`, wa = (e) => {
  const t = Te.find(
    (o) => o.name.toLowerCase() === e.toLowerCase()
  );
  return (t == null ? void 0 : t.variants) || [{ weight: 500, label: "Medium" }];
};
let ve = null;
const io = () => ve || (ve = new Promise((e) => {
  const t = Te.map((r) => ({
    name: r.name,
    weights: [400, 500]
  })), o = va(t), a = document.createElement("link");
  a.href = o, a.rel = "stylesheet", a.onload = () => {
    e();
  }, a.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(a);
}), ve), Sa = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, lt = (e) => {
  const t = Sa(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, le = (e, t, o) => {
  var r;
  const a = {
    type: to,
    payload: { updateType: t, themeId: o }
  };
  (r = e == null ? void 0 : e.current) != null && r.contentWindow ? e.current.contentWindow.postMessage(
    a,
    window.location.origin
  ) : window.postMessage(a, window.location.origin);
}, Ba = (e) => {
  var o;
  switch ((o = e.split(".").pop()) == null ? void 0 : o.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, Fa = ({
  themeId: e,
  editThemeToken: t,
  iframeRef: o,
  refreshThemeColors: a,
  refreshThemeFonts: r,
  refreshThemeIcons: l
}) => {
  const [c, s] = P(!1), [d, m] = P(null), [g, y] = P(null), [b, u] = P(!1), [S, p] = P(""), [k, v] = P("#000000ff"), [z, F] = P(
    null
  ), T = async () => {
    if (!S.trim()) {
      m("Color name is required");
      return;
    }
    if (!t || !e) {
      m("Theme ID and edit token are required");
      return;
    }
    s(!0), m(null), y(null);
    try {
      await tt({
        themeId: e,
        colorKey: S.trim(),
        colorValue: lt(k),
        editThemeToken: t
      }), await a(), le(o, "colors", e), p(""), v("#000000ff"), u(!1), y("Color added successfully"), setTimeout(() => y(null), 2e3);
    } catch (w) {
      m(w.message || "Failed to add color");
    } finally {
      s(!1);
    }
  }, D = async (w, A) => {
    if (!(!t || !e)) {
      s(!0), m(null), y(null);
      try {
        await tt({
          themeId: e,
          colorKey: w,
          colorValue: lt(A),
          editThemeToken: t
        }), await a(), le(o, "colors", e), y("Color updated successfully"), setTimeout(() => y(null), 2e3);
      } catch (L) {
        m(L.message || "Failed to update color");
      } finally {
        s(!1);
      }
    }
  }, H = async (w, A) => {
    if (!(!t || !e)) {
      if (!A.trim()) {
        m("Color name is required");
        return;
      }
      if (w !== A.trim()) {
        s(!0), m(null), y(null);
        try {
          await pa({
            themeId: e,
            oldColorKey: w,
            newColorKey: A.trim(),
            editThemeToken: t
          }), await a(), le(o, "colors", e), y("Color renamed successfully"), setTimeout(() => y(null), 2e3);
        } catch (L) {
          m(L.message || "Failed to rename color");
        } finally {
          s(!1);
        }
      }
    }
  }, M = (w) => {
    !t || !e || F({ type: "color", key: w });
  }, x = async (w) => {
    if (!(!t || !e)) {
      s(!0), m(null), y(null);
      try {
        await da({
          themeId: e,
          colorKey: w,
          editThemeToken: t
        }), await a(), le(o, "colors", e), y("Color deleted successfully"), setTimeout(() => y(null), 2e3);
      } catch (A) {
        m(A.message || "Failed to delete color");
      } finally {
        s(!1);
      }
    }
  }, O = async (w) => {
    if (!t || !e) {
      m("Theme ID and edit token are required");
      return;
    }
    s(!0), m(null), y(null);
    try {
      let A, L;
      switch (w.type) {
        case "system":
          A = w.value || w.name, L = "system";
          break;
        case "google":
          const G = wa(w.name).map((te) => te.weight);
          G.includes(800) || G.push(800), G.includes(900) || G.push(900), A = Ca(w.name, G), L = "google";
          break;
        case "upload":
          if (!w.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: _, objectPublicUrl: Y } = await ot({
            themeId: e,
            fileName: w.file.name,
            contentType: w.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: t
          });
          await at({
            file: w.file,
            signedUploadUrl: _
          }), A = Y, L = Ba(w.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await ma({
        themeId: e,
        fontKey: w.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: w.name,
          url: A,
          format: L
        },
        editThemeToken: t
      }), await r(), le(o, "fonts", e), y("Font added successfully"), setTimeout(() => y(null), 2e3);
    } catch (A) {
      m(A.message || "Failed to add font");
    } finally {
      s(!1);
    }
  }, R = (w) => {
    !t || !e || F({ type: "font", key: w });
  }, I = async (w) => {
    if (!(!t || !e)) {
      s(!0), m(null), y(null);
      try {
        await ga({
          themeId: e,
          fontKey: w,
          editThemeToken: t
        }), await r(), le(o, "fonts", e), y("Font deleted successfully"), setTimeout(() => y(null), 2e3);
      } catch (A) {
        m(A.message || "Failed to delete font");
      } finally {
        s(!1);
      }
    }
  }, W = async (w) => {
    if (!t || !e) {
      m("Theme ID and edit token are required");
      return;
    }
    s(!0), m(null), y(null);
    try {
      let A;
      switch (w.type) {
        case "lucide":
          if (A = w.url || "", !A)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!w.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: L, objectPublicUrl: $ } = await ot({
            themeId: e,
            fileName: w.file.name,
            contentType: w.file.type || "image/svg+xml",
            assetType: "icon",
            editThemeToken: t
          });
          await at({
            file: w.file,
            signedUploadUrl: L
          }), A = $;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await ua({
        themeId: e,
        iconKey: w.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: w.name,
          url: A
        },
        editThemeToken: t
      }), await l(), le(o, "icons", e), y("Icon added successfully"), setTimeout(() => y(null), 2e3);
    } catch (A) {
      m(A.message || "Failed to add icon");
    } finally {
      s(!1);
    }
  }, C = (w) => {
    !t || !e || F({ type: "icon", key: w });
  }, E = async (w) => {
    if (!(!t || !e)) {
      s(!0), m(null), y(null);
      try {
        await ha({
          themeId: e,
          iconKey: w,
          editThemeToken: t
        }), await l(), le(o, "icons", e), y("Icon deleted successfully"), setTimeout(() => y(null), 2e3);
      } catch (A) {
        m(A.message || "Failed to delete icon");
      } finally {
        s(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: c,
    error: d,
    successMessage: g,
    // Color state
    isAddingColor: b,
    setIsAddingColor: u,
    newColorKey: S,
    setNewColorKey: p,
    newColorValue: k,
    setNewColorValue: v,
    // Color Handlers
    handleAddColor: T,
    handleUpdateColor: D,
    handleRenameColor: H,
    handleDeleteColor: M,
    // Font Handlers
    handleAddFont: O,
    handleDeleteFont: R,
    // Icon Handlers
    handleAddIcon: W,
    handleDeleteIcon: C,
    // Delete confirmation
    pendingDelete: z,
    confirmDelete: async () => {
      if (!z) return;
      const { type: w, key: A } = z;
      switch (F(null), w) {
        case "color":
          await x(A);
          break;
        case "font":
          await I(A);
          break;
        case "icon":
          await E(A);
          break;
      }
    },
    cancelDelete: () => {
      F(null);
    }
  };
}, st = ({
  onClose: e,
  successMessage: t,
  error: o,
  children: a
}) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ h("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ n("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ n(
      J,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ n(de, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ h("div", { className: "bc-theme-editor-sidepanel-content", children: [
    t && /* @__PURE__ */ h("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ n(Lo, { size: 14 }),
      " ",
      t
    ] }),
    o && /* @__PURE__ */ h("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ n(Go, { size: 14 }),
      " ",
      o
    ] }),
    a
  ] })
] });
function Ae() {
  return (Ae = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var a in o) Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }
    return e;
  }).apply(this, arguments);
}
function lo(e, t) {
  if (e == null) return {};
  var o, a, r = {}, l = Object.keys(e);
  for (a = 0; a < l.length; a++) t.indexOf(o = l[a]) >= 0 || (r[o] = e[o]);
  return r;
}
function De(e) {
  var t = q(e), o = q(function(a) {
    t.current && t.current(a);
  });
  return t.current = e, o.current;
}
var be = function(e, t, o) {
  return t === void 0 && (t = 0), o === void 0 && (o = 1), e > o ? o : e < t ? t : e;
}, ye = function(e) {
  return "touches" in e;
}, Re = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, ct = function(e, t, o) {
  var a = e.getBoundingClientRect(), r = ye(t) ? function(l, c) {
    for (var s = 0; s < l.length; s++) if (l[s].identifier === c) return l[s];
    return l[0];
  }(t.touches, o) : t;
  return { left: be((r.pageX - (a.left + Re(e).pageXOffset)) / a.width), top: be((r.pageY - (a.top + Re(e).pageYOffset)) / a.height) };
}, dt = function(e) {
  !ye(e) && e.preventDefault();
}, so = V.memo(function(e) {
  var t = e.onMove, o = e.onKey, a = lo(e, ["onMove", "onKey"]), r = q(null), l = De(t), c = De(o), s = q(null), d = q(!1), m = ae(function() {
    var u = function(k) {
      dt(k), (ye(k) ? k.touches.length > 0 : k.buttons > 0) && r.current ? l(ct(r.current, k, s.current)) : p(!1);
    }, S = function() {
      return p(!1);
    };
    function p(k) {
      var v = d.current, z = Re(r.current), F = k ? z.addEventListener : z.removeEventListener;
      F(v ? "touchmove" : "mousemove", u), F(v ? "touchend" : "mouseup", S);
    }
    return [function(k) {
      var v = k.nativeEvent, z = r.current;
      if (z && (dt(v), !function(T, D) {
        return D && !ye(T);
      }(v, d.current) && z)) {
        if (ye(v)) {
          d.current = !0;
          var F = v.changedTouches || [];
          F.length && (s.current = F[0].identifier);
        }
        z.focus(), l(ct(z, v, s.current)), p(!0);
      }
    }, function(k) {
      var v = k.which || k.keyCode;
      v < 37 || v > 40 || (k.preventDefault(), c({ left: v === 39 ? 0.05 : v === 37 ? -0.05 : 0, top: v === 40 ? 0.05 : v === 38 ? -0.05 : 0 }));
    }, p];
  }, [c, l]), g = m[0], y = m[1], b = m[2];
  return Q(function() {
    return b;
  }, [b]), V.createElement("div", Ae({}, a, { onTouchStart: g, onMouseDown: g, className: "react-colorful__interactive", ref: r, onKeyDown: y, tabIndex: 0, role: "slider" }));
}), Xe = function(e) {
  return e.filter(Boolean).join(" ");
}, co = function(e) {
  var t = e.color, o = e.left, a = e.top, r = a === void 0 ? 0.5 : a, l = Xe(["react-colorful__pointer", e.className]);
  return V.createElement("div", { className: l, style: { top: 100 * r + "%", left: 100 * o + "%" } }, V.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, K = function(e, t, o) {
  return t === void 0 && (t = 0), o === void 0 && (o = Math.pow(10, t)), Math.round(o * e) / o;
}, Ea = function(e) {
  return Aa(je(e));
}, je = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? K(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? K(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, za = function(e) {
  return Pa(Ia(e));
}, Ta = function(e) {
  var t = e.s, o = e.v, a = e.a, r = (200 - t) * o / 100;
  return { h: K(e.h), s: K(r > 0 && r < 200 ? t * o / 100 / (r <= 100 ? r : 200 - r) * 100 : 0), l: K(r / 2), a: K(a, 2) };
}, We = function(e) {
  var t = Ta(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, Ia = function(e) {
  var t = e.h, o = e.s, a = e.v, r = e.a;
  t = t / 360 * 6, o /= 100, a /= 100;
  var l = Math.floor(t), c = a * (1 - o), s = a * (1 - (t - l) * o), d = a * (1 - (1 - t + l) * o), m = l % 6;
  return { r: K(255 * [a, s, c, c, d, a][m]), g: K(255 * [d, a, a, s, c, c][m]), b: K(255 * [c, c, d, a, a, s][m]), a: K(r, 2) };
}, we = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, Pa = function(e) {
  var t = e.r, o = e.g, a = e.b, r = e.a, l = r < 1 ? we(K(255 * r)) : "";
  return "#" + we(t) + we(o) + we(a) + l;
}, Aa = function(e) {
  var t = e.r, o = e.g, a = e.b, r = e.a, l = Math.max(t, o, a), c = l - Math.min(t, o, a), s = c ? l === t ? (o - a) / c : l === o ? 2 + (a - t) / c : 4 + (t - o) / c : 0;
  return { h: K(60 * (s < 0 ? s + 6 : s)), s: K(l ? c / l * 100 : 0), v: K(l / 255 * 100), a: r };
}, Ma = V.memo(function(e) {
  var t = e.hue, o = e.onChange, a = Xe(["react-colorful__hue", e.className]);
  return V.createElement("div", { className: a }, V.createElement(so, { onMove: function(r) {
    o({ h: 360 * r.left });
  }, onKey: function(r) {
    o({ h: be(t + 360 * r.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": K(t), "aria-valuemax": "360", "aria-valuemin": "0" }, V.createElement(co, { className: "react-colorful__hue-pointer", left: t / 360, color: We({ h: t, s: 100, v: 100, a: 1 }) })));
}), Na = V.memo(function(e) {
  var t = e.hsva, o = e.onChange, a = { backgroundColor: We({ h: t.h, s: 100, v: 100, a: 1 }) };
  return V.createElement("div", { className: "react-colorful__saturation", style: a }, V.createElement(so, { onMove: function(r) {
    o({ s: 100 * r.left, v: 100 - 100 * r.top });
  }, onKey: function(r) {
    o({ s: be(t.s + 100 * r.left, 0, 100), v: be(t.v - 100 * r.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + K(t.s) + "%, Brightness " + K(t.v) + "%" }, V.createElement(co, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: We(t) })));
}), po = function(e, t) {
  if (e === t) return !0;
  for (var o in e) if (e[o] !== t[o]) return !1;
  return !0;
}, Ha = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || po(je(e), je(t));
};
function Oa(e, t, o) {
  var a = De(o), r = P(function() {
    return e.toHsva(t);
  }), l = r[0], c = r[1], s = q({ color: t, hsva: l });
  Q(function() {
    if (!e.equal(t, s.current.color)) {
      var m = e.toHsva(t);
      s.current = { hsva: m, color: t }, c(m);
    }
  }, [t, e]), Q(function() {
    var m;
    po(l, s.current.hsva) || e.equal(m = e.fromHsva(l), s.current.color) || (s.current = { hsva: l, color: m }, a(m));
  }, [l, e, a]);
  var d = se(function(m) {
    c(function(g) {
      return Object.assign({}, g, m);
    });
  }, []);
  return [l, d];
}
var Da = typeof window < "u" ? vo : Q, Ra = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, pt = /* @__PURE__ */ new Map(), ja = function(e) {
  Da(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !pt.has(t)) {
      var o = t.createElement("style");
      o.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, pt.set(t, o);
      var a = Ra();
      a && o.setAttribute("nonce", a), t.head.appendChild(o);
    }
  }, []);
}, Wa = function(e) {
  var t = e.className, o = e.colorModel, a = e.color, r = a === void 0 ? o.defaultColor : a, l = e.onChange, c = lo(e, ["className", "colorModel", "color", "onChange"]), s = q(null);
  ja(s);
  var d = Oa(o, r, l), m = d[0], g = d[1], y = Xe(["react-colorful", t]);
  return V.createElement("div", Ae({}, c, { ref: s, className: y }), V.createElement(Na, { hsva: m, onChange: g }), V.createElement(Ma, { hue: m.h, onChange: g, className: "react-colorful__last-control" }));
}, La = { defaultColor: "000", toHsva: Ea, fromHsva: function(e) {
  return za({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: Ha }, Qa = function(e) {
  return V.createElement(Wa, Ae({}, e, { colorModel: La }));
};
const mt = (e) => {
  const t = e.startsWith("#") ? e : `#${e}`, o = t.slice(0, 7).padEnd(7, "0"), a = t.slice(7, 9) || "ff", r = parseInt(a, 16), l = Math.round(r / 255 * 100);
  return { hex: o, opacity: l };
}, me = (e, t) => {
  const o = Math.round(t / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${o}`;
}, gt = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, mo = ({
  value: e,
  onChange: t,
  className: o
}) => {
  const { hex: a, opacity: r } = mt(
    e || "#000000ff"
  ), [l, c] = P(a), [s, d] = P(r), [m, g] = P(
    r < 100 ? e || "#000000ff" : a
  );
  Q(() => {
    const { hex: p, opacity: k } = mt(
      e || "#000000ff"
    );
    c(p), d(k), g(k < 100 ? e || "#000000ff" : p);
  }, [e]);
  const y = (p) => {
    c(p), g(s < 100 ? me(p, s) : p), t(me(p, s));
  }, b = (p) => {
    const k = p.target.value;
    g(k);
    const v = gt(k);
    if (v)
      if (v.length === 9) {
        const z = v.slice(0, 7), F = v.slice(7, 9), T = parseInt(F, 16), D = Math.round(T / 255 * 100);
        c(z), d(D), t(v);
      } else
        c(v), t(me(v, s));
  }, u = () => {
    const p = gt(m);
    if (p)
      if (p.length === 9)
        g(p);
      else {
        const k = me(p, s);
        g(s < 100 ? k : p);
      }
    else {
      const k = me(l, s);
      g(s < 100 ? k : l);
    }
  }, S = (p) => {
    const k = parseInt(p.target.value, 10);
    d(k);
    const v = me(l, k);
    t(v), g(k < 100 ? v : l);
  };
  return /* @__PURE__ */ h("div", { className: `bc-color-picker ${o || ""}`, children: [
    /* @__PURE__ */ n("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${i.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${i.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${i.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${i.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${i.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${l} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${i.white};
          border: 2px solid ${i.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${i.white};
          border: 2px solid ${i.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${i.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ n(Qa, { color: l, onChange: y }),
    /* @__PURE__ */ n(
      "input",
      {
        type: "text",
        value: m,
        onChange: b,
        onBlur: u,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ h("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: s,
          onChange: S,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${l} 100%)`
          }
        }
      ),
      /* @__PURE__ */ n("span", { className: "bc-color-picker-opacity-value", children: s })
    ] })
  ] });
}, Ga = "data:image/png;base64,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", Le = ({
  color: e,
  size: t = 32,
  borderRadius: o = 4,
  className: a,
  style: r
}) => /* @__PURE__ */ h(
  "div",
  {
    className: a,
    style: {
      position: "relative",
      width: t,
      height: t,
      borderRadius: o,
      overflow: "hidden",
      ...r
    },
    children: [
      /* @__PURE__ */ n(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${Ga})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ n(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), Ze = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, ut = (e) => {
  const t = Ze(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, Ne = (e) => {
  const t = Ze(e || "#000000");
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, ht = ({
  themeColors: e,
  isExpanded: t,
  onToggle: o,
  isLoading: a,
  isAddingColor: r,
  setIsAddingColor: l,
  newColorKey: c,
  setNewColorKey: s,
  newColorValue: d,
  setNewColorValue: m,
  onAddColor: g,
  onUpdateColor: y,
  onRenameColor: b,
  onDeleteColor: u
}) => {
  const [S, p] = P(null), k = q({}), [v, z] = P({
    top: 0,
    left: 0,
    openAbove: !1
  }), [F, T] = P(null), [D, H] = P(null), [M, x] = P(""), [O, R] = P(""), I = 300;
  Q(() => {
    if (S && k.current[S]) {
      const C = k.current[S].getBoundingClientRect(), B = window.innerHeight - C.bottom, N = C.top, w = B < I && N > B;
      z({
        top: w ? C.top - 8 : C.bottom + 8,
        left: C.left + C.width / 2,
        openAbove: w
      });
    }
  }, [S]), Q(() => {
    if (!S) return;
    const C = (E) => {
      const B = E.target;
      !B.closest(".bc-theme-color-popover") && !B.closest(".bc-theme-color-swatch") && p(null);
    };
    return document.addEventListener("mousedown", C), () => {
      document.removeEventListener("mousedown", C);
    };
  }, [S]);
  const W = (C, E, B, N) => {
    const w = S === C, A = Ze(E), L = !a;
    return /* @__PURE__ */ h(j, { children: [
      L ? /* @__PURE__ */ n(
        "button",
        {
          ref: ($) => {
            k.current[C] = $;
          },
          type: "button",
          onClick: () => p(w ? null : C),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${i.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: i.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ n(
            Le,
            {
              color: A,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ n(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${i.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: i.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ n(
            Le,
            {
              color: A,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      w && L && ge.createPortal(
        /* @__PURE__ */ n(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: v.top,
              left: v.left,
              transform: v.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: i.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${i.shadow_medium}, 0 0 0 1px ${i.border_glass}`
            },
            onClick: ($) => $.stopPropagation(),
            children: /* @__PURE__ */ n(mo, { value: A, onChange: B })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ h("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ n("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${i.gray_border};
          transform: scale(1.05);
        }
      ` }),
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
      /* @__PURE__ */ h("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ n("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ n(
        Je,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ n("div", { className: "bc-theme-editor-section-content", children: a && Object.keys(e).length === 0 ? /* @__PURE__ */ n("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ h("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([C, E]) => {
        const B = F === C, N = D === C, w = N ? O : Ne(E), A = B ? M : C, L = () => {
          B && M.trim() && M.trim() !== C && b && b(C, M.trim()), T(null), x("");
        }, $ = (Y) => {
          Y.key === "Enter" ? Y.currentTarget.blur() : Y.key === "Escape" && (T(null), x(""));
        }, G = () => {
          if (N && O.trim()) {
            const Y = ut(O.trim());
            Y !== ut(E) && y(C, Y);
          }
          H(null), R("");
        }, _ = (Y) => {
          Y.key === "Enter" ? Y.currentTarget.blur() : Y.key === "Escape" && (H(null), R(""));
        };
        return /* @__PURE__ */ h("div", { className: "bc-theme-editor-row", children: [
          B ? /* @__PURE__ */ n(
            "input",
            {
              type: "text",
              className: "bc-theme-editor-input",
              value: A,
              onChange: (Y) => x(Y.target.value),
              onBlur: L,
              onKeyDown: $,
              disabled: a,
              autoFocus: !0
            }
          ) : /* @__PURE__ */ n(
            "input",
            {
              type: "text",
              className: "bc-theme-editor-input",
              value: C,
              onFocus: () => {
                T(C), x(C);
              },
              readOnly: !0,
              style: { cursor: "text" }
            }
          ),
          W(
            C,
            E,
            (Y) => y(C, Y)
          ),
          N ? /* @__PURE__ */ n(
            "input",
            {
              type: "text",
              className: "bc-theme-editor-input",
              value: w,
              onChange: (Y) => R(Y.target.value),
              onBlur: G,
              onKeyDown: _,
              disabled: a,
              autoFocus: !0,
              placeholder: "#000000 or #000000ff",
              maxLength: 9,
              style: {
                width: "85px",
                textAlign: "right",
                fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
              }
            }
          ) : /* @__PURE__ */ n(
            "span",
            {
              className: "bc-theme-editor-color-value",
              onClick: () => {
                H(C), R(Ne(E));
              },
              style: { cursor: "text" },
              children: Ne(E)
            }
          ),
          /* @__PURE__ */ n(
            "button",
            {
              className: "bc-theme-editor-delete-btn",
              onClick: () => u(C),
              disabled: a,
              "aria-label": "Delete color",
              children: /* @__PURE__ */ n(de, { size: 16 })
            }
          )
        ] }, C);
      }),
      r ? /* @__PURE__ */ h("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ n(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: c,
            onChange: (C) => s(C.target.value),
            disabled: a,
            autoFocus: !0
          }
        ),
        W(
          "__new_color__",
          d,
          m
        ),
        /* @__PURE__ */ n(
          J,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ n(Ee, { size: 12 }),
            onClick: g,
            disabled: a || !c.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ n(
          J,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              l(!1), s(""), m("#000000ff");
            },
            disabled: a,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ n(
        J,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ n(Ye, { size: 12 }),
          onClick: () => l(!0),
          disabled: a,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, yt = ({
  themeFonts: e,
  isExpanded: t,
  onToggle: o,
  isLoading: a,
  onDeleteFont: r,
  onOpenFontPicker: l
}) => {
  const [c, s] = P(!1);
  Q(() => {
    t && !c && io().then(() => s(!0));
  }, [t, c]);
  const d = (m) => {
    switch (m) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return m;
    }
  };
  return /* @__PURE__ */ h("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
      /* @__PURE__ */ h("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ n("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ n(
        Je,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ n("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ h("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([m, g]) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-row bc-font-row", children: [
        /* @__PURE__ */ n(
          "span",
          {
            className: "bc-font-preview-name",
            style: {
              fontFamily: c ? `'${g.name}', sans-serif` : "inherit"
            },
            children: g.name
          }
        ),
        /* @__PURE__ */ n("span", { className: "bc-theme-editor-asset-format", children: d(g.format) }),
        /* @__PURE__ */ n(
          "button",
          {
            className: "bc-theme-editor-delete-btn",
            onClick: () => r(m),
            disabled: a,
            "aria-label": "Delete font",
            children: /* @__PURE__ */ n(de, { size: 16 })
          }
        )
      ] }, m)),
      /* @__PURE__ */ n(
        J,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ n(Ye, { size: 12 }),
          onClick: l,
          disabled: a,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, bt = ({
  themeIcons: e,
  isExpanded: t,
  onToggle: o,
  isLoading: a,
  onDeleteIcon: r,
  onOpenIconPicker: l
}) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ h("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
    /* @__PURE__ */ h("h3", { className: "bc-theme-editor-section-title", children: [
      "Icons",
      /* @__PURE__ */ n("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ n(
      Je,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
      }
    )
  ] }),
  t && /* @__PURE__ */ n("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ h("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([c, s]) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ n("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ n("img", { src: s.url, alt: s.name }) }),
      /* @__PURE__ */ n(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: s.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ n(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => r(c),
          disabled: a,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ n(de, { size: 16 })
        }
      )
    ] }, c)),
    /* @__PURE__ */ n(
      J,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ n(Ye, { size: 12 }),
        onClick: l,
        disabled: a,
        children: "Add Icon"
      }
    )
  ] }) })
] }), ft = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], Ja = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${i.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${i.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${i.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${i.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${i.blue};
    background: ${i.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${i.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${i.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${i.primary};
  }

  .font-picker-tab.active {
    color: ${i.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${i.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${i.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${i.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-item:hover {
    background: ${i.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${i.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${i.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${i.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${i.bg_light};
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${i.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${i.primary};
    background: ${i.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${i.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${i.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${i.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${i.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${i.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${i.border_glass};
    background: ${i.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, xt = ({
  isOpen: e,
  onClose: t,
  onSelect: o,
  isLoading: a = !1
}) => {
  const [r, l] = P("system"), [c, s] = P(""), [d, m] = P(null), [g, y] = P(null), [b, u] = P(""), S = q(null), [p, k] = P(!1);
  Q(() => {
    e && (s(""), m(null), y(null), u(""));
  }, [e]), Q(() => {
    r === "google" && !p && io().then(() => {
      k(!0);
    });
  }, [r, p]);
  const v = ae(() => {
    if (!c) return ft;
    const C = c.toLowerCase();
    return ft.filter(
      (E) => E.name.toLowerCase().includes(C) || E.category.toLowerCase().includes(C)
    );
  }, [c]), z = ae(() => {
    if (!c) return Te;
    const C = c.toLowerCase();
    return Te.filter(
      (E) => E.name.toLowerCase().includes(C) || E.category.toLowerCase().includes(C)
    );
  }, [c]), F = (C) => {
    m({
      type: "system",
      name: C.name,
      value: C.value
    });
  }, T = (C) => {
    m({
      type: "google",
      name: C.name
    });
  }, D = (C) => {
    var B;
    const E = (B = C.target.files) == null ? void 0 : B[0];
    if (E) {
      y(E);
      const N = E.name.replace(/\.[^/.]+$/, "");
      u(N), m({
        type: "upload",
        name: N,
        file: E,
        format: H(E.name)
      });
    }
  }, H = (C) => {
    var B;
    switch ((B = C.split(".").pop()) == null ? void 0 : B.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, M = (C) => {
    u(C), (d == null ? void 0 : d.type) === "upload" && g && m({
      ...d,
      name: C
    });
  }, x = () => {
    d && (o(d), t());
  }, O = a || !d || d.type === "upload" && (!g || !b.trim()), R = ae(() => {
    const C = {};
    return z.forEach((E) => {
      C[E.category] || (C[E.category] = []), C[E.category].push(E);
    }), C;
  }, [z]), I = ae(() => {
    const C = {};
    return v.forEach((E) => {
      C[E.category] || (C[E.category] = []), C[E.category].push(E);
    }), C;
  }, [v]);
  if (!e) return null;
  const W = /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: Ja() }),
    /* @__PURE__ */ n("div", { className: "font-picker-overlay", onClick: t, children: /* @__PURE__ */ h("div", { className: "font-picker-modal", onClick: (C) => C.stopPropagation(), children: [
      /* @__PURE__ */ h("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ n("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ n(
          J,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ n(de, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ n(Kt, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ n(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: c,
            onChange: (C) => s(C.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ n(
          "button",
          {
            className: `font-picker-tab ${r === "system" ? "active" : ""}`,
            onClick: () => l("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ n(
          "button",
          {
            className: `font-picker-tab ${r === "google" ? "active" : ""}`,
            onClick: () => l("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ n(
          "button",
          {
            className: `font-picker-tab ${r === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-content", children: [
        r === "system" && /* @__PURE__ */ h("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ n("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(I).map(
            ([C, E]) => /* @__PURE__ */ h("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ n("h4", { className: "font-picker-category-title", children: C.charAt(0).toUpperCase() + C.slice(1) }),
              E.map((B) => /* @__PURE__ */ h(
                "div",
                {
                  className: `font-picker-item ${(d == null ? void 0 : d.type) === "system" && (d == null ? void 0 : d.name) === B.name ? "selected" : ""}`,
                  onClick: () => F(B),
                  children: [
                    /* @__PURE__ */ n(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: B.value },
                        children: B.name
                      }
                    ),
                    (d == null ? void 0 : d.type) === "system" && (d == null ? void 0 : d.name) === B.name && /* @__PURE__ */ n(Ee, { size: 16, className: "font-picker-check" })
                  ]
                },
                B.name
              ))
            ] }, C)
          )
        ] }),
        r === "google" && /* @__PURE__ */ h("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ n("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(R).map(
            ([C, E]) => /* @__PURE__ */ h("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ n("h4", { className: "font-picker-category-title", children: C.charAt(0).toUpperCase() + C.slice(1) }),
              E.map((B) => {
                const N = (d == null ? void 0 : d.type) === "google" && (d == null ? void 0 : d.name) === B.name;
                return /* @__PURE__ */ n("div", { children: /* @__PURE__ */ h(
                  "div",
                  {
                    className: `font-picker-item ${N ? "selected" : ""}`,
                    onClick: () => T(B),
                    children: [
                      /* @__PURE__ */ n(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: p ? `'${B.name}', sans-serif` : "inherit"
                          },
                          children: B.name
                        }
                      ),
                      N && /* @__PURE__ */ n(
                        Ee,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, B.name);
              })
            ] }, C)
          )
        ] }),
        r === "upload" && /* @__PURE__ */ h("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ n("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ n(
            "input",
            {
              ref: S,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: D,
              style: { display: "none" }
            }
          ),
          g ? /* @__PURE__ */ h("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ h("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ n("span", { className: "font-picker-upload-filename", children: g.name }),
              /* @__PURE__ */ n(
                J,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var C;
                    return (C = S.current) == null ? void 0 : C.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ h("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ n("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ n(
                "input",
                {
                  type: "text",
                  value: b,
                  onChange: (C) => M(C.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ h(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var C;
                return (C = S.current) == null ? void 0 : C.click();
              },
              children: [
                /* @__PURE__ */ n(_t, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ n("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ n("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ n(J, { variant: "outline", onClick: t, disabled: a, children: "Cancel" }),
        /* @__PURE__ */ n(
          J,
          {
            variant: "primary",
            onClick: x,
            disabled: O,
            children: a ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return ge.createPortal(W, Pe());
}, kt = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], Ie = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], Ct = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, Ya = (e) => {
  const t = e.toLowerCase().trim();
  return t ? Ie.filter(
    (o) => o.name.toLowerCase().includes(t) || o.tags.some((a) => a.toLowerCase().includes(t)) || o.category.toLowerCase().includes(t)
  ) : Ie;
}, vt = (e) => Ie.filter((t) => t.category === e), Xa = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${i.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${i.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${i.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${i.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${i.blue};
    background: ${i.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${i.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${i.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${i.primary};
  }

  .icon-picker-tab.active {
    color: ${i.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${i.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${i.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${i.border_glass};
    border-radius: 20px;
    background: ${i.white};
    font-size: 12px;
    font-weight: 500;
    color: ${i.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${i.blue};
    color: ${i.blue};
  }

  .icon-picker-category-btn.active {
    background: ${i.primary};
    border-color: ${i.primary};
    color: ${i.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${i.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${i.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${i.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${i.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${i.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${i.bg_light};
    border-top: 1px solid ${i.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${i.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${i.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${i.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${i.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-svg-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-svg-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${i.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${i.border_glass};
    background: ${i.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, wt = ({
  isOpen: e,
  onClose: t,
  onSelect: o,
  isLoading: a = !1
}) => {
  const [r, l] = P("lucide"), [c, s] = P(""), [d, m] = P(null), [g, y] = P("all"), [b, u] = P(null), [S, p] = P(""), [k, v] = P(null), z = q(null);
  Q(() => {
    e && (s(""), m(null), y("all"), u(null), p(""), v(null));
  }, [e]);
  const F = ae(() => {
    let I;
    return c ? I = Ya(c) : g === "all" ? I = Ie : I = vt(g), I;
  }, [c, g]), T = ae(() => {
    if (c || g !== "all")
      return {
        [g === "all" ? "results" : g]: F
      };
    const I = {};
    return kt.forEach((W) => {
      I[W] = vt(W);
    }), I;
  }, [F, c, g]), D = (I) => {
    m({
      type: "lucide",
      name: I.name,
      url: Ct(I.name)
    });
  }, H = async (I) => {
    var C;
    const W = (C = I.target.files) == null ? void 0 : C[0];
    if (W) {
      u(W);
      const E = W.name.replace(/\.[^/.]+$/, "");
      p(E);
      const B = new FileReader();
      B.onload = (N) => {
        var A;
        const w = (A = N.target) == null ? void 0 : A.result;
        v(w);
      }, B.readAsText(W), m({
        type: "upload",
        name: E,
        file: W
      });
    }
  }, M = (I) => {
    p(I), (d == null ? void 0 : d.type) === "upload" && b && m({
      ...d,
      name: I
    });
  }, x = () => {
    d && (o(d), t());
  }, O = a || !d || d.type === "upload" && (!b || !S.trim());
  if (!e) return null;
  const R = /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: Xa() }),
    /* @__PURE__ */ n("div", { className: "icon-picker-overlay", onClick: t, children: /* @__PURE__ */ h("div", { className: "icon-picker-modal", onClick: (I) => I.stopPropagation(), children: [
      /* @__PURE__ */ h("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ n("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ n(
          J,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ n(de, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ n(Kt, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ n(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: c,
            onChange: (I) => s(I.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ n(
          "button",
          {
            className: `icon-picker-tab ${r === "lucide" ? "active" : ""}`,
            onClick: () => l("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ n(
          "button",
          {
            className: `icon-picker-tab ${r === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload SVG"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-content", children: [
        r === "lucide" && /* @__PURE__ */ h(j, { children: [
          /* @__PURE__ */ h("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ n(
              "button",
              {
                className: `icon-picker-category-btn ${g === "all" ? "active" : ""}`,
                onClick: () => y("all"),
                children: "All"
              }
            ),
            kt.map((I) => /* @__PURE__ */ n(
              "button",
              {
                className: `icon-picker-category-btn ${g === I ? "active" : ""}`,
                onClick: () => y(I),
                children: I.charAt(0).toUpperCase() + I.slice(1)
              },
              I
            ))
          ] }),
          /* @__PURE__ */ h("div", { className: "icon-picker-icons-container", children: [
            Object.entries(T).map(([I, W]) => /* @__PURE__ */ h(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !c && g === "all" && /* @__PURE__ */ n("h4", { className: "icon-picker-category-title", children: I.charAt(0).toUpperCase() + I.slice(1) }),
                  /* @__PURE__ */ n("div", { className: "icon-picker-grid", children: W.map((C) => /* @__PURE__ */ h(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(d == null ? void 0 : d.type) === "lucide" && (d == null ? void 0 : d.name) === C.name ? "selected" : ""}`,
                      onClick: () => D(C),
                      title: C.name,
                      children: [
                        /* @__PURE__ */ n(
                          "img",
                          {
                            src: Ct(C.name),
                            alt: C.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (d == null ? void 0 : d.type) === "lucide" && (d == null ? void 0 : d.name) === C.name && /* @__PURE__ */ n("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ n(Ee, { size: 12 }) })
                      ]
                    },
                    C.name
                  )) })
                ]
              },
              I
            )),
            F.length === 0 && /* @__PURE__ */ n("div", { className: "icon-picker-empty", children: /* @__PURE__ */ h("p", { children: [
              'No icons found for "',
              c,
              '"'
            ] }) })
          ] }),
          (d == null ? void 0 : d.type) === "lucide" && /* @__PURE__ */ h("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ n(
              "img",
              {
                src: d.url,
                alt: d.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ n("span", { className: "icon-picker-selected-name", children: d.name })
          ] })
        ] }),
        r === "upload" && /* @__PURE__ */ h("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ n("p", { className: "icon-picker-description", children: "Upload your own SVG icon file." }),
          /* @__PURE__ */ n(
            "input",
            {
              ref: z,
              type: "file",
              accept: ".svg",
              onChange: H,
              style: { display: "none" }
            }
          ),
          b ? /* @__PURE__ */ h("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ h("div", { className: "icon-picker-upload-file", children: [
              k && /* @__PURE__ */ n(
                "div",
                {
                  className: "icon-picker-svg-preview",
                  dangerouslySetInnerHTML: { __html: k }
                }
              ),
              /* @__PURE__ */ h("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ n("span", { className: "icon-picker-upload-filename", children: b.name }),
                /* @__PURE__ */ n(
                  J,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var I;
                      return (I = z.current) == null ? void 0 : I.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ h("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ n("label", { className: "icon-picker-upload-label", children: "Icon name" }),
              /* @__PURE__ */ n(
                "input",
                {
                  type: "text",
                  value: S,
                  onChange: (I) => M(I.target.value),
                  placeholder: "Enter icon name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ h(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var I;
                return (I = z.current) == null ? void 0 : I.click();
              },
              children: [
                /* @__PURE__ */ n(_t, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ n("span", { className: "icon-picker-upload-text", children: "Click to upload SVG file" }),
                /* @__PURE__ */ n("span", { className: "icon-picker-upload-hint", children: "SVG only" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ n(J, { variant: "outline", onClick: t, disabled: a, children: "Cancel" }),
        /* @__PURE__ */ n(
          J,
          {
            variant: "primary",
            onClick: x,
            disabled: O,
            children: a ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return ge.createPortal(R, Pe());
}, fe = ({
  title: e,
  message: t,
  confirmLabel: o = "Save",
  cancelLabel: a = "Discard",
  onConfirm: r,
  onCancel: l,
  isLoading: c = !1
}) => {
  const s = /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${i.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${i.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${i.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
        }
      ` }),
    /* @__PURE__ */ n("div", { className: "confirm-dialog-overlay", onClick: l, children: /* @__PURE__ */ h(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (d) => d.stopPropagation(),
        children: [
          /* @__PURE__ */ n("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ n("p", { className: "confirm-dialog-message", children: t }),
          /* @__PURE__ */ h("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ n(
              J,
              {
                variant: "ghost",
                size: "sm",
                onClick: l,
                disabled: c,
                children: a
              }
            ),
            /* @__PURE__ */ n(
              J,
              {
                variant: "primary",
                size: "sm",
                onClick: r,
                isLoading: c,
                disabled: c,
                children: o
              }
            )
          ] })
        ]
      }
    ) })
  ] });
  return ge.createPortal(s, Pe());
}, or = () => {
  const e = xe(), t = ro(), [o, a] = P("checking"), [r, l] = P("desktop"), c = q(null), [s, d] = P(!1), { data: m } = ke(), g = (m == null ? void 0 : m.themeName) || e.themeId, { themeColors: y, refreshThemeColors: b } = oo(), { themeFonts: u, refreshThemeFonts: S } = ao(), { themeIcons: p, refreshThemeIcons: k } = no(), [v, z] = P(null), [F, T] = P(!1), [D, H] = P(!1), M = (E) => {
    z((B) => B === E ? null : E);
  }, x = Fa({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: o === "iframe" ? c : null,
    refreshThemeColors: b,
    refreshThemeFonts: S,
    refreshThemeIcons: k
  });
  Q(() => {
    t || Eo();
  }, [t]), Q(() => {
    if (t || !e.themeId) return;
    (async () => {
      const B = await xa();
      a(B ? "iframe" : "inline");
    })();
  }, [t, e.themeId]);
  const O = se(() => {
    var E;
    if (c.current)
      try {
        const B = new URL(
          ((E = c.current.contentWindow) == null ? void 0 : E.location.href) || ""
        ), N = new URL(window.location.href);
        N.pathname = B.pathname;
        const w = new URLSearchParams(B.search), A = new URLSearchParams();
        e.themeId && A.set("themeId", e.themeId), e.editMode && A.set("editMode", "true"), e.editThemeToken && A.set("editThemeToken", e.editThemeToken), w.forEach((L, $) => {
          $ !== "frameMode" && $ !== "themeId" && $ !== "editMode" && $ !== "editThemeToken" && A.set($, L);
        }), N.search = A.toString(), window.history.replaceState({}, "", N.toString());
      } catch (B) {
        console.debug("Could not access iframe URL (cross-origin):", B);
      }
  }, [e]);
  if (!e.themeId || t)
    return null;
  if (o === "checking")
    return /* @__PURE__ */ h(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ n(Yo, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ n("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ n("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const R = () => {
    Fo(), zo();
    const E = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = E;
  }, I = () => {
    d(!s);
  }, W = async (E) => {
    await x.handleAddFont(E);
  }, C = async (E) => {
    await x.handleAddIcon(E);
  };
  return o === "inline" ? /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: it({ showSettings: s, viewMode: r, editorMode: o }) }),
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ h("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ n("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ n(_e, { size: 18 }) }),
          /* @__PURE__ */ n("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ n("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ n("span", { className: "bc-theme-editor-theme-id", children: g }),
          (m == null ? void 0 : m.isPublished) && /* @__PURE__ */ h("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ n("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ n("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ n(
            J,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ n(et, { size: 14 }),
              onClick: I,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ n(
            J,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ n(Ke, { size: 14 }),
              onClick: R,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      s && /* @__PURE__ */ h(
        st,
        {
          onClose: () => d(!1),
          successMessage: x.successMessage,
          error: x.error,
          children: [
            /* @__PURE__ */ n(
              ht,
              {
                themeColors: y,
                isExpanded: v === "colors",
                onToggle: () => M("colors"),
                isLoading: x.isLoading,
                isAddingColor: x.isAddingColor,
                setIsAddingColor: x.setIsAddingColor,
                newColorKey: x.newColorKey,
                setNewColorKey: x.setNewColorKey,
                newColorValue: x.newColorValue,
                setNewColorValue: x.setNewColorValue,
                onAddColor: x.handleAddColor,
                onUpdateColor: x.handleUpdateColor,
                onRenameColor: x.handleRenameColor,
                onDeleteColor: x.handleDeleteColor
              }
            ),
            /* @__PURE__ */ n(
              yt,
              {
                themeFonts: u,
                isExpanded: v === "fonts",
                onToggle: () => M("fonts"),
                isLoading: x.isLoading,
                onDeleteFont: x.handleDeleteFont,
                onOpenFontPicker: () => T(!0)
              }
            ),
            /* @__PURE__ */ n(
              bt,
              {
                themeIcons: p,
                isExpanded: v === "icons",
                onToggle: () => M("icons"),
                isLoading: x.isLoading,
                onDeleteIcon: x.handleDeleteIcon,
                onOpenIconPicker: () => H(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ n(
        xt,
        {
          isOpen: F,
          onClose: () => T(!1),
          onSelect: W,
          isLoading: x.isLoading
        }
      ),
      /* @__PURE__ */ n(
        wt,
        {
          isOpen: D,
          onClose: () => H(!1),
          onSelect: C,
          isLoading: x.isLoading
        }
      ),
      x.pendingDelete && /* @__PURE__ */ n(
        fe,
        {
          title: `Delete ${x.pendingDelete.type}`,
          message: `Are you sure you want to delete "${x.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: x.confirmDelete,
          onCancel: x.cancelDelete,
          isLoading: x.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: it({ showSettings: s, viewMode: r, editorMode: o }) }),
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ h("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ n("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ n(_e, { size: 18 }) }),
          /* @__PURE__ */ n("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ n("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ n("span", { className: "bc-theme-editor-theme-id", children: g }),
          (m == null ? void 0 : m.isPublished) && /* @__PURE__ */ h("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ n("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ n(
            J,
            {
              variant: r === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ n(Uo, { size: 16 })
            }
          ),
          /* @__PURE__ */ n(
            J,
            {
              variant: r === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ n(aa, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ n("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ n(
            J,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ n(et, { size: 14 }),
              onClick: I,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ n(
            J,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ n(Ke, { size: 14 }),
              onClick: R,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ n("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ n("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ n("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ n(
        "iframe",
        {
          ref: c,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: O,
          title: "Theme Preview"
        }
      ) }) }) }),
      s && /* @__PURE__ */ h(
        st,
        {
          onClose: () => d(!1),
          successMessage: x.successMessage,
          error: x.error,
          children: [
            /* @__PURE__ */ n(
              ht,
              {
                themeColors: y,
                isExpanded: v === "colors",
                onToggle: () => M("colors"),
                isLoading: x.isLoading,
                isAddingColor: x.isAddingColor,
                setIsAddingColor: x.setIsAddingColor,
                newColorKey: x.newColorKey,
                setNewColorKey: x.setNewColorKey,
                newColorValue: x.newColorValue,
                setNewColorValue: x.setNewColorValue,
                onAddColor: x.handleAddColor,
                onUpdateColor: x.handleUpdateColor,
                onRenameColor: x.handleRenameColor,
                onDeleteColor: x.handleDeleteColor
              }
            ),
            /* @__PURE__ */ n(
              yt,
              {
                themeFonts: u,
                isExpanded: v === "fonts",
                onToggle: () => M("fonts"),
                isLoading: x.isLoading,
                onDeleteFont: x.handleDeleteFont,
                onOpenFontPicker: () => T(!0)
              }
            ),
            /* @__PURE__ */ n(
              bt,
              {
                themeIcons: p,
                isExpanded: v === "icons",
                onToggle: () => M("icons"),
                isLoading: x.isLoading,
                onDeleteIcon: x.handleDeleteIcon,
                onOpenIconPicker: () => H(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ n(
        xt,
        {
          isOpen: F,
          onClose: () => T(!1),
          onSelect: W,
          isLoading: x.isLoading
        }
      ),
      /* @__PURE__ */ n(
        wt,
        {
          isOpen: D,
          onClose: () => H(!1),
          onSelect: C,
          isLoading: x.isLoading
        }
      ),
      x.pendingDelete && /* @__PURE__ */ n(
        fe,
        {
          title: `Delete ${x.pendingDelete.type}`,
          message: `Are you sure you want to delete "${x.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: x.confirmDelete,
          onCancel: x.cancelDelete,
          isLoading: x.isLoading
        }
      )
    ] })
  ] });
}, Za = () => {
  const [e, t] = P({ x: 0, y: 0 }), [o, a] = P(!1), r = q({ x: 0, y: 0 }), l = (c) => {
    a(!0), r.current = {
      x: c.clientX - e.x,
      y: c.clientY - e.y
    };
  };
  return Q(() => {
    const c = (d) => {
      o && t({
        x: d.clientX - r.current.x,
        y: d.clientY - r.current.y
      });
    }, s = () => {
      a(!1);
    };
    if (o) {
      const d = Oe();
      return d.addEventListener("mousemove", c), d.addEventListener("mouseup", s), () => {
        d.removeEventListener("mousemove", c), d.removeEventListener("mouseup", s);
      };
    }
  }, [o]), { dragOffset: e, isDragging: o, handleMouseDown: l };
}, Ua = ({ value: e, onChange: t }) => {
  const [o, a] = P(e || "");
  return Q(() => {
    a(e || "");
  }, [e]), /* @__PURE__ */ n(
    "input",
    {
      type: "text",
      value: o,
      onChange: (l) => {
        const c = l.target.value;
        a(c), t(c);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${i.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: i.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: i.white,
        outline: "none"
      }
    }
  );
}, $a = ({
  value: e,
  onChange: t,
  field: o
}) => {
  var a, r;
  return /* @__PURE__ */ n(
    "select",
    {
      value: e ?? ((r = (a = o.options) == null ? void 0 : a[0]) == null ? void 0 : r.value) ?? "",
      onChange: (l) => t(l.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${i.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: i.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: i.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (o.options ?? []).map((l) => /* @__PURE__ */ n("option", { value: l.value, children: l.label }, l.value))
    }
  );
}, he = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, St = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, qa = ({
  value: e,
  onChange: t,
  field: o,
  themeColors: a,
  openColorPicker: r,
  setOpenColorPicker: l,
  selectedThemeColors: c,
  setSelectedThemeColors: s
}) => {
  const m = (() => {
    if (c[o.key])
      return c[o.key];
    const x = he(e || "#000000ff").toLowerCase();
    for (const [O, R] of Object.entries(a))
      if (he(R).toLowerCase() === x)
        return O;
    return "";
  })(), g = (x) => {
    s((O) => ({
      ...O,
      [o.key]: x
    })), x && a[x] && t(a[x]);
  }, y = (x) => {
    s((O) => ({
      ...O,
      [o.key]: ""
    })), t(x);
  }, b = r === o.key, u = e || "#000000ff", S = q(null), p = q(null), [k, v] = V.useState(!1), z = (x) => {
    const O = he(x);
    return O.length === 9 && O.slice(7, 9).toLowerCase() === "ff" ? O.slice(0, 7) : O;
  }, [F, T] = P(() => z(u));
  Q(() => {
    T(z(e || "#000000ff"));
  }, [e]);
  const D = (x) => {
    const O = x.target.value;
    T(O);
    const R = St(O);
    if (R) {
      const I = he(R);
      y(I);
    }
  }, H = () => {
    const x = St(F);
    if (!x)
      T(z(u));
    else {
      const O = he(x);
      T(z(O));
    }
  }, M = 300;
  return Q(() => {
    if (b && p.current) {
      const x = p.current.getBoundingClientRect(), R = window.innerHeight - x.bottom, I = x.top;
      v(R < M && I > R);
    }
  }, [b]), Q(() => {
    if (!b) return;
    const x = (O) => {
      S.current && !S.current.contains(O.target) && l(null);
    };
    return document.addEventListener("mousedown", x, !0), () => {
      document.removeEventListener("mousedown", x, !0);
    };
  }, [b, l]), /* @__PURE__ */ h(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ h(
          "select",
          {
            value: m,
            onChange: (x) => g(x.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${i.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: i.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: i.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ n("option", { value: "", children: "Custom" }),
              Object.keys(a).map((x) => /* @__PURE__ */ n("option", { value: x, children: x }, x))
            ]
          }
        ),
        /* @__PURE__ */ h("div", { ref: S, style: { position: "relative" }, children: [
          /* @__PURE__ */ n(
            "button",
            {
              ref: p,
              type: "button",
              onClick: () => l(b ? null : o.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${i.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: i.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ n(
                Le,
                {
                  color: u,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          b && /* @__PURE__ */ n(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...k ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: i.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${i.shadow_medium}, 0 0 0 1px ${i.border_glass}`
              },
              onClick: (x) => x.stopPropagation(),
              children: /* @__PURE__ */ n(
                mo,
                {
                  value: u,
                  onChange: y
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ n(
          "input",
          {
            type: "text",
            value: F,
            onChange: D,
            onBlur: H,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${i.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: i.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: i.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (x) => x.target.select()
          }
        )
      ]
    }
  );
}, Va = ({
  value: e,
  onChange: t,
  field: o
}) => /* @__PURE__ */ n(
  "input",
  {
    type: "number",
    value: e || 0,
    min: o.min,
    max: o.max,
    step: o.step || 1,
    onChange: (a) => t(parseFloat(a.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${i.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: i.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: i.white,
      outline: "none"
    }
  }
), Ka = ({ value: e, onChange: t }) => {
  const o = !!e;
  return /* @__PURE__ */ n(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": o,
      onClick: () => t(!o),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: o ? i.blue : i.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: o ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ n(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: i.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, _a = ({
  value: e,
  onChange: t,
  themeFonts: o
}) => /* @__PURE__ */ h(
  "select",
  {
    value: e || "inherit",
    onChange: (a) => t(a.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${i.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: i.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: i.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ n("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(o).map(([a, r]) => /* @__PURE__ */ n("option", { value: a, children: r.name }, a))
    ]
  }
), en = ({
  value: e,
  onChange: t,
  themeIcons: o
}) => /* @__PURE__ */ h(
  "select",
  {
    value: e || "default",
    onChange: (a) => t(a.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${i.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: i.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: i.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ n("option", { value: "default", children: "Default" }),
      Object.entries(o).map(([a, r]) => /* @__PURE__ */ n("option", { value: a, children: r.name }, a))
    ]
  }
), go = ({
  displayName: e,
  fields: t,
  values: o,
  initialValues: a,
  onChange: r,
  onClose: l,
  onReset: c,
  screenPosition: s,
  onSave: d,
  isSaving: m = !1,
  themeColors: g = {},
  themeFonts: y = {},
  themeIcons: b = {}
}) => {
  const { dragOffset: u, isDragging: S, handleMouseDown: p } = Za(), k = q(null), [v, z] = P({}), [F, T] = P(null), [D, H] = P(!1), M = ae(() => a ? JSON.stringify(o) !== JSON.stringify(a) : !1, [o, a]), x = () => {
    M ? H(!0) : l();
  }, O = () => {
    H(!1), l();
  }, R = async () => {
    d && d(), H(!1);
  };
  Q(() => {
    if (!F) return;
    const B = Oe(), N = (w) => {
      const A = w.target;
      !A.closest(".edit-panel-color-popover") && !A.closest(".edit-panel-color-swatch") && T(null);
    };
    return B.addEventListener("mousedown", N, !0), () => {
      B.removeEventListener("mousedown", N, !0);
    };
  }, [F]), Q(() => {
    if (!ro()) return;
    const B = Oe(), N = "edit-panel-styles";
    if (!B.getElementById(N)) {
      const w = B.createElement("style");
      w.id = N, w.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, B.head.appendChild(w);
    }
    return () => {
      const w = B.getElementById(N);
      w && w.remove();
    };
  }, []);
  const I = ae(() => {
    const B = [], N = {};
    return t.forEach((w) => {
      if (w.group)
        N[w.group] || (N[w.group] = []), N[w.group].push(w);
      else {
        const A = w.key.match(/^elementStyles\.([^.]+)\./);
        if (A) {
          const L = A[1];
          N[L] || (N[L] = []), N[L].push(w);
        } else
          B.push(w);
      }
    }), { baseFields: B, groups: N };
  }, [t]), W = (B) => ({
    h1: "H1",
    h2: "H2",
    h3: "H3",
    h4: "H4",
    h5: "H5",
    h6: "H6",
    p: "Paragraph",
    strong: "Bold",
    em: "Italic",
    code: "Code",
    blockquote: "Blockquote",
    ul: "Unordered List",
    ol: "Ordered List",
    li: "List Item",
    table: "Table",
    thead: "Table Header",
    tbody: "Table Body",
    tr: "Table Row",
    th: "Header Cell",
    td: "Table Cell",
    // Product Card Carousel groups
    carousel: "Carousel",
    "Card Container": "Card Container",
    title: "Title",
    price: "Price",
    "Retailer Icons": "Retailer Icons",
    image: "Image"
  })[B] || B, C = (B) => {
    const N = o[B.key];
    switch (B.type) {
      case "text":
        return /* @__PURE__ */ n(
          Ua,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B
          }
        );
      case "options":
        return /* @__PURE__ */ n(
          $a,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B
          }
        );
      case "color":
        return /* @__PURE__ */ n(
          qa,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B,
            themeColors: g,
            openColorPicker: F,
            setOpenColorPicker: T,
            selectedThemeColors: v,
            setSelectedThemeColors: z
          }
        );
      case "number":
        return /* @__PURE__ */ n(
          Va,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B
          }
        );
      case "toggle":
        return /* @__PURE__ */ n(
          Ka,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B
          }
        );
      case "font":
        return /* @__PURE__ */ n(
          _a,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B,
            themeFonts: y
          }
        );
      case "icon":
        return /* @__PURE__ */ n(
          en,
          {
            value: N,
            onChange: (w) => r(B.key, w),
            field: B,
            themeIcons: b
          }
        );
      default:
        return null;
    }
  }, E = /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .edit-panel-close {
          transition: all 0.15s ease;
        }

        .edit-panel-close:hover {
          background-color: ${i.overlay_light};
          color: ${i.primary};
          transform: scale(1.1);
        }

        .edit-panel-input:focus,
        .edit-panel-select:focus {
          border-color: ${i.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
        }

        .edit-panel-input:hover:not(:focus),
        .edit-panel-select:hover:not(:focus) {
          border-color: ${i.gray_border};
        }

        .edit-panel-color-text:focus {
          border-color: ${i.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${i.white};
        }

        .edit-panel-color-swatch:hover {
          border-color: ${i.gray_border};
          transform: scale(1.05);
        }

        /* ColorPicker popover styles are now in the ColorPicker component */

        .drag-handle {
          cursor: ${S ? "grabbing" : "grab"};
          transition: background-color 0.15s ease;
        }

        .drag-handle:hover {
          background-color: ${i.overlay_light};
        }

        .edit-panel-save-button {
          background: linear-gradient(135deg, ${i.blue} 0%, ${i.blue_dark} 100%);
          color: ${i.white};
          border: none;
          padding: 10px 18px;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
          letter-spacing: 0.3px;
        }

        .edit-panel-save-button:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
        }

        .edit-panel-save-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .edit-panel-save-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Custom scrollbar */
        .edit-panel-content::-webkit-scrollbar {
          width: 6px;
        }

        .edit-panel-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .edit-panel-content::-webkit-scrollbar-thumb {
          background: ${i.gray_border};
          border-radius: 3px;
        }

        .edit-panel-content::-webkit-scrollbar-thumb:hover {
          background: ${i.gray_medium};
        }
      ` }),
    /* @__PURE__ */ h(
      "div",
      {
        ref: k,
        style: {
          position: "fixed",
          top: s.y + u.y,
          left: s.x + u.x,
          background: i.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${i.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${i.shadow_medium},
            0 20px 60px ${i.shadow_soft},
            0 0 0 1px ${i.border_glass}
          `,
          zIndex: 999999,
          width: "620px",
          maxWidth: "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (B) => B.stopPropagation(),
        onMouseDown: (B) => B.stopPropagation(),
        children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "drag-handle",
              onMouseDown: p,
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                borderBottom: `1px solid ${i.border_glass}`,
                borderRadius: "20px 20px 0 0",
                userSelect: "none"
              },
              children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      flex: 1
                    },
                    children: [
                      /* @__PURE__ */ n(
                        "div",
                        {
                          style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "3px",
                            opacity: 0.3
                          },
                          children: [...Array(6)].map((B, N) => /* @__PURE__ */ n(
                            "div",
                            {
                              style: {
                                width: "4px",
                                height: "4px",
                                background: i.gray_medium,
                                borderRadius: "1px"
                              }
                            },
                            N
                          ))
                        }
                      ),
                      /* @__PURE__ */ n(
                        "h3",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: 600,
                            color: i.primary,
                            margin: 0,
                            letterSpacing: "0.2px"
                          },
                          children: e || "Edit Properties"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ h("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
                  M && c && /* @__PURE__ */ n(
                    J,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: c,
                      disabled: m,
                      "aria-label": "Reset changes",
                      leftIcon: /* @__PURE__ */ n(_o, { size: 14 }),
                      children: "Reset"
                    }
                  ),
                  M && d && /* @__PURE__ */ n(
                    J,
                    {
                      variant: "primary",
                      size: "sm",
                      onClick: d,
                      disabled: m,
                      isLoading: m,
                      "aria-label": "Save changes",
                      type: "submit",
                      children: "Save"
                    }
                  ),
                  /* @__PURE__ */ n(
                    J,
                    {
                      variant: "icon",
                      size: "md",
                      onClick: x,
                      "aria-label": "Close",
                      children: /* @__PURE__ */ n(de, { size: 18 })
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: "edit-panel-content",
              style: {
                padding: "20px 24px 24px",
                overflowY: "auto",
                overflowX: "hidden",
                flex: 1
              },
              children: /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px"
                  },
                  children: [
                    I.baseFields.length > 0 && /* @__PURE__ */ n(
                      "div",
                      {
                        style: {
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "20px"
                        },
                        children: I.baseFields.map((B) => /* @__PURE__ */ h(
                          "div",
                          {
                            style: {
                              minWidth: 0
                            },
                            children: [
                              /* @__PURE__ */ n(
                                "label",
                                {
                                  style: {
                                    display: "block",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: i.gray_medium,
                                    marginBottom: "8px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px"
                                  },
                                  children: B.label
                                }
                              ),
                              C(B)
                            ]
                          },
                          B.key
                        ))
                      }
                    ),
                    Object.entries(I.groups).map(
                      ([B, N]) => /* @__PURE__ */ h("div", { children: [
                        /* @__PURE__ */ n(
                          "h4",
                          {
                            style: {
                              fontSize: "12px",
                              fontWeight: 700,
                              color: i.primary,
                              margin: "0 0 16px 0",
                              paddingBottom: "8px",
                              borderBottom: `2px solid ${i.border_glass}`,
                              textTransform: "uppercase",
                              letterSpacing: "0.5px"
                            },
                            children: W(B)
                          }
                        ),
                        /* @__PURE__ */ n(
                          "div",
                          {
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "20px"
                            },
                            children: N.map((w) => /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  minWidth: 0
                                },
                                children: [
                                  /* @__PURE__ */ n(
                                    "label",
                                    {
                                      style: {
                                        display: "block",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: i.gray_medium,
                                        marginBottom: "8px",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px"
                                      },
                                      children: w.label
                                    }
                                  ),
                                  C(w)
                                ]
                              },
                              w.key
                            ))
                          }
                        )
                      ] }, B)
                    )
                  ]
                }
              )
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ h(j, { children: [
    ge.createPortal(E, Pe()),
    D && /* @__PURE__ */ n(
      fe,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: R,
        onCancel: O,
        isLoading: m
      }
    )
  ] });
}, uo = () => xe().editMode, Qe = "bc-widget-panel-opened", ho = (e) => {
  const t = new CustomEvent(Qe, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(t);
}, yo = (e) => {
  const t = (o) => {
    e(o.detail.widgetId);
  };
  return document.addEventListener(Qe, t), () => {
    document.removeEventListener(Qe, t);
  };
}, tn = (e, t = 32, o = 4) => {
  const a = window.innerWidth, r = window.innerHeight, l = a < 768, c = e.left, s = a - e.right, d = e.top, m = r - e.bottom, g = t + o, y = c >= g, b = s >= g, u = d >= g, S = m >= g;
  let p = "top-left", k = {};
  return l ? b && u ? (p = "top-right", k = {
    top: e.top - o,
    left: e.right - t + o
  }) : b && S ? (p = "bottom-right", k = {
    top: e.bottom - t + o,
    left: e.right - t + o
  }) : y && u ? (p = "top-left", k = {
    top: e.top - o,
    left: e.left - o
  }) : y && S ? (p = "bottom-left", k = {
    top: e.bottom - t + o,
    left: e.left - o
  }) : (p = "top-right", k = {
    top: e.top + o,
    left: e.right - t - o
  }) : y && u ? (p = "top-left", k = {
    top: e.top - o,
    left: e.left - o
  }) : b && u ? (p = "top-right", k = {
    top: e.top - o,
    left: e.right - t + o
  }) : y && S ? (p = "bottom-left", k = {
    top: e.bottom - t + o,
    left: e.left - o
  }) : b && S ? (p = "bottom-right", k = {
    top: e.bottom - t + o,
    left: e.right - t + o
  }) : (p = "top-left", k = {
    top: e.top + o,
    left: e.left + o
  }), { position: p, style: k };
}, U = ({
  children: e,
  widgetId: t,
  displayName: o,
  editFields: a,
  editValues: r,
  onEditChange: l,
  onSave: c,
  isSaving: s = !1,
  themeColors: d = {},
  themeFonts: m = {},
  themeIcons: g = {}
}) => {
  const [y, b] = P(!1), [u, S] = P({ x: 0, y: 0 }), [p, k] = P(null), [v, z] = P(!1), [F, T] = P(
    null
  ), [D, H] = P(!1), [M, x] = P(!1), O = q(null), R = q(null), I = uo(), W = (D || M) && !y, C = se(() => {
    if (R.current) {
      const G = R.current.getBoundingClientRect(), { style: _ } = tn(G);
      T(_);
    }
  }, []);
  Q(() => {
    if (!I || !W) {
      T(null);
      return;
    }
    C();
    const G = () => C();
    return window.addEventListener("scroll", G, !0), window.addEventListener("resize", G), () => {
      window.removeEventListener("scroll", G, !0), window.removeEventListener("resize", G);
    };
  }, [I, W, C]);
  const E = se(() => p ? JSON.stringify(r) !== JSON.stringify(p) : !1, [r, p]);
  if (Q(() => t ? yo((_) => {
    _ !== t && y && (E() ? z(!0) : b(!1));
  }) : void 0, [t, y, E]), !I)
    return /* @__PURE__ */ n(j, { children: e });
  const B = () => {
    if (O.current) {
      const G = O.current.getBoundingClientRect(), _ = window.innerWidth, Y = window.innerHeight, te = 620, ne = 450, oe = 10, Ue = Y - G.bottom, $e = G.top, ko = _ - G.left, Co = G.right;
      let ce;
      Ue >= ne + oe ? ce = G.bottom + oe : $e >= ne + oe ? ce = G.top - ne - oe : Ue >= $e ? ce = Math.max(oe, Y - ne - oe) : ce = Math.max(oe, G.top - ne - oe);
      let pe;
      ko >= te ? pe = G.left : Co >= te ? pe = G.right - te : pe = Math.max(
        oe,
        Math.min(_ - te - oe, G.left)
      ), pe = Math.max(oe, Math.min(pe, _ - te - oe)), ce = Math.max(oe, Math.min(ce, Y - ne - oe)), S({ x: pe, y: ce });
    }
    k({ ...r }), b(!0), t && ho(t);
  }, N = () => {
    p && Object.keys(p).forEach((G) => {
      l(G, p[G]);
    });
  }, w = () => {
    c && c(), k({ ...r });
  }, A = () => {
    z(!1), b(!1);
  }, L = () => {
    w(), z(!1), b(!1);
  }, $ = () => {
    if (!F) return null;
    const G = /* @__PURE__ */ n(
      "button",
      {
        ref: O,
        style: {
          position: "fixed",
          top: F.top,
          left: F.left,
          width: 32,
          height: 32,
          background: M ? i.blue_light : i.white,
          border: `1px solid ${M ? i.blue : i.gray_border}`,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          transition: "background 0.2s, border-color 0.2s, transform 0.2s",
          transform: M ? "scale(1.05)" : "scale(1)",
          zIndex: 999998,
          padding: 0
        },
        onClick: (_) => {
          _.stopPropagation(), _.preventDefault(), B();
        },
        onMouseEnter: () => x(!0),
        onMouseLeave: () => x(!1),
        "aria-label": "Edit widget",
        children: /* @__PURE__ */ n(Vt, { size: 16, color: i.gray_dark })
      }
    );
    return ge.createPortal(G, document.body);
  };
  return /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${i.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${i.blue};
        }
      ` }),
    /* @__PURE__ */ h(
      "div",
      {
        ref: R,
        className: `widget-wrapper${y ? " widget-editing" : W ? " widget-hovered" : ""}`,
        onMouseEnter: () => H(!0),
        onMouseLeave: () => H(!1),
        children: [
          e,
          y && /* @__PURE__ */ n(
            go,
            {
              widgetId: t,
              displayName: o,
              fields: a,
              values: r,
              initialValues: p || void 0,
              onChange: l,
              onClose: () => b(!1),
              onReset: N,
              screenPosition: u,
              onSave: w,
              isSaving: s,
              themeColors: d,
              themeFonts: m,
              themeIcons: g
            }
          ),
          v && /* @__PURE__ */ n(
            fe,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: L,
              onCancel: A,
              isLoading: s
            }
          )
        ]
      }
    ),
    W && $()
  ] });
};
function Z(e, t, o) {
  const { isLoading: a, ...r } = ba(
    e,
    t
  ), l = r, [c, s] = P(!1), { themeColors: d } = oo(), { themeFonts: m } = ao(), { themeIcons: g } = no(), y = xe(), { updateWidgetConfig: b, getWidgetState: u } = fa(e), S = ae(() => {
    const F = {};
    return o.forEach((T) => {
      F[T.key] = T.type;
    }), F;
  }, [o]), p = se(
    (F, T) => {
      const D = S[F];
      let H = T;
      switch (D) {
        case "toggle":
          typeof T == "string" && (H = T === "true");
          break;
        case "number":
          if (typeof T == "string" && T !== "") {
            const M = parseFloat(T);
            isNaN(M) || (H = M);
          }
          break;
        case "options":
          typeof T == "string" && (T === "true" ? H = !0 : T === "false" ? H = !1 : /^\d+$/.test(T) && (H = parseInt(T, 10)));
          break;
      }
      b(F, H);
    },
    [S, b]
  ), k = !!(y.themeId && y.editThemeToken && e), v = se(async () => {
    if (!y.themeId || !y.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    s(!0);
    try {
      const F = u() || l;
      await ca({
        themeId: y.themeId,
        widgetId: e,
        widgetState: F,
        editThemeToken: y.editThemeToken
      });
    } catch (F) {
      console.error("Failed to save widget config:", F), alert(`Failed to save: ${F.message}`);
    } finally {
      s(!1);
    }
  }, [y, e, u, l]), z = se(() => {
    const F = { ...l };
    return o.forEach((T) => {
      const D = F[T.key];
      T.type === "options" && (typeof D == "boolean" ? F[T.key] = D ? "true" : "false" : typeof D == "number" && (F[T.key] = String(D)));
    }), F;
  }, [l, o]);
  return {
    state: l,
    isLoading: a,
    isSaving: c,
    handleEditChange: p,
    handleSave: v,
    themeColors: d,
    themeFonts: m,
    themeIcons: g,
    canSave: k,
    getEditValues: z
  };
}
const ue = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], X = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
ue.slice(
  0,
  4
);
const on = ue.slice(1, 4), an = ue.slice(0, 3), nn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, rn = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: "#181d56",
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, Bt = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: X
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], ar = ({
  initialState: e = {},
  widgetId: t,
  displayName: o
}) => {
  const {
    state: a,
    isLoading: r,
    isSaving: l,
    handleEditChange: c,
    handleSave: s,
    themeColors: d,
    themeFonts: m,
    canSave: g
  } = Z(
    t,
    { ...rn, ...e },
    Bt
  ), y = a.fontFamily, b = y && y !== "inherit" ? m[y] : null, u = b && b.format === "google" ? b.url : null;
  if (Q(() => {
    u && nn(u);
  }, [u]), r)
    return /* @__PURE__ */ n(j, {});
  const S = (T) => {
    const D = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, H = parseInt(T, 10);
    return isNaN(H) ? D[T] || 500 : H;
  }, p = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", k = `textbox-${t || "default"}`, z = `
    ${b && b.format !== "system" && b.format !== "google" ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${p !== "inherit" ? `.${k} { font-family: ${p} !important; }` : ""}
  `.trim(), F = /* @__PURE__ */ h(j, { children: [
    z && /* @__PURE__ */ n("style", { children: z }),
    /* @__PURE__ */ n(
      "span",
      {
        className: `textbox-content ${k}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...p === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${a.fontSize}px`,
          fontWeight: S(a.fontWeight),
          color: a.color,
          textAlign: a.textAlign,
          lineHeight: a.lineHeight,
          letterSpacing: `${a.letterSpacing}px`,
          textTransform: a.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: a.content
      }
    )
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Bt,
      editValues: a,
      onEditChange: c,
      onSave: g ? s : void 0,
      isSaving: l,
      themeColors: d,
      themeFonts: m,
      children: F
    }
  );
}, ln = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, sn = {
  // Border styling
  borderColor: "#DCDDDC",
  borderColorFocus: "#DCDDDC",
  borderRadiusSingleLine: 100,
  // pill shape
  borderRadiusMultiLine: 20,
  // rounded
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: "#181d56",
  submitButtonBgColorHover: "#333333",
  submitButtonIconColor: "#FFFFFF",
  submitButtonSize: 24,
  submitButtonBorderRadius: 14,
  // Action icons (attachment, mic)
  iconColor: "#181d56",
  iconColorHover: "#333333",
  iconSize: 24,
  micActiveColor: "#EF4444",
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 16,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: "#181d56",
  placeholderColor: "#9CA3AF",
  // Layout
  paddingX: 12,
  paddingY: 12,
  maxWidth: 768,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0
}, Ft = [
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: X
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], nr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    themeIcons: y,
    canSave: b,
    getEditValues: u
  } = Z(
    t,
    { ...sn, ...e },
    Ft
  ), S = r.fontFamily, p = S && S !== "inherit" ? g[S] : null, k = p && p.format === "google" ? p.url : null;
  if (Q(() => {
    k && ln(k);
  }, [k]), l)
    return /* @__PURE__ */ n(j, {});
  const v = p ? p.format === "system" ? p.url : `"${p.name}", sans-serif` : "inherit", z = p && p.format !== "system" && p.format !== "google", F = `chat-input-${t || "default"}`, T = `
    ${z ? `
      @font-face {
        font-family: "${p.name}";
        src: url("${p.url}") format("${p.format}");
        font-display: swap;
      }
    ` : ""}
    ${v !== "inherit" ? `.${F} { font-family: ${v} !important; }` : ""}
  `.trim(), D = {
    ...r,
    fontFamilyCss: v
  }, H = /* @__PURE__ */ h(j, { children: [
    T && /* @__PURE__ */ n("style", { children: T }),
    a(D, y)
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Ft,
      editValues: u(),
      onEditChange: s,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      themeIcons: y,
      children: H
    }
  );
}, cn = {
  // Pill styling (matching Figma design)
  pillBgColor: "#FFFFFF",
  pillBgColorHover: "#F6F8FA",
  pillTextColor: "#181d56",
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: "#181d56",
  // Selected state styling
  pillBgColorSelected: "#181d56",
  pillTextColorSelected: "#FFFFFF",
  pillBorderColorSelected: "#181d56",
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Et = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: ue
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], rr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...cn, ...e },
    Et
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Et,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, zt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, dn = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: { fontSize: 16, fontWeight: "500", lineHeight: 1.6, marginBottom: 4 },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: { fontWeight: "600" },
  tbody: { fontWeight: "500" },
  tr: {},
  th: { fontSize: 14, fontWeight: "600", lineHeight: 1.4 },
  td: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 }
}, pn = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: "#E8F4FD",
  // blueWhite-like for user
  textColor: i.primary,
  // Border radius
  borderRadius: 10,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Element styles with defaults
  elementStyles: dn
}, Se = (e, t) => {
  const o = `elementStyles.${e}`;
  return [
    {
      key: `${o}.fontFamily`,
      label: `${t} Font`,
      type: "font"
    },
    {
      key: `${o}.fontSize`,
      label: `${t} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${o}.fontWeight`,
      label: `${t} Font Weight`,
      type: "options",
      options: ue
    },
    {
      key: `${o}.color`,
      label: `${t} Color`,
      type: "color"
    },
    {
      key: `${o}.lineHeight`,
      label: `${t} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${o}.marginTop`,
      label: `${t} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${o}.marginBottom`,
      label: `${t} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ];
}, Be = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, bo = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: an
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], mn = ["h1", "h2", "h3"], gn = ["p", "blockquote"], un = ["li"], hn = ["th", "td"], yn = [
  ...mn.flatMap(
    (e) => Se(e, Be[e])
  ),
  ...gn.flatMap(
    (e) => Se(e, Be[e])
  ),
  ...un.flatMap(
    (e) => Se(e, Be[e])
  ),
  ...hn.flatMap(
    (e) => Se(e, Be[e])
  )
], bn = [...bo, ...yn], fn = (e, t, o) => {
  if (!t) return "";
  const a = [], r = [], l = /* @__PURE__ */ new Set();
  for (const [c, s] of Object.entries(t)) {
    if (!s) continue;
    const d = [];
    if (s.fontSize !== void 0 && d.push(`font-size: ${s.fontSize}px !important`), s.fontWeight !== void 0 && d.push(`font-weight: ${s.fontWeight} !important`), s.color && s.color !== "inherit" && d.push(`color: ${s.color} !important`), s.lineHeight !== void 0 && d.push(`line-height: ${s.lineHeight} !important`), s.marginTop !== void 0 && d.push(`margin-top: ${s.marginTop}px !important`), s.marginBottom !== void 0 && d.push(`margin-bottom: ${s.marginBottom}px !important`), s.fontFamily && s.fontFamily !== "inherit") {
      const m = o[s.fontFamily];
      m && (m.format === "system" ? d.push(`font-family: ${m.url} !important`) : (d.push(
        `font-family: "${m.name}", sans-serif !important`
      ), m.format !== "google" && !l.has(m.name) && (r.push(`
              @font-face {
                font-family: "${m.name}";
                src: url("${m.url}") format("${m.format}");
                font-display: swap;
              }
            `), l.add(m.name))));
    }
    d.length > 0 && a.push(`#concierge-mount .${e} .message-content ${c},
#concierge-mount .${e} .message-content .message-markdown ${c},
.${e} .message-content ${c},
.${e} .message-content .message-markdown ${c} {
  ${d.join(`;
  `)};
}`);
  }
  return [...r, ...a].join(`

`);
}, xn = (e, t, o) => {
  const a = t.split("."), r = { ...e };
  let l = r;
  for (let c = 0; c < a.length - 1; c++) {
    const s = a[c];
    l[s] = { ...l[s] }, l = l[s];
  }
  return l[a[a.length - 1]] = o, r;
}, kn = (e) => {
  const t = {};
  for (const [o, a] of Object.entries(e))
    if (o === "elementStyles" && typeof a == "object" && a !== null) {
      for (const [r, l] of Object.entries(
        a
      ))
        if (l && typeof l == "object")
          for (const [c, s] of Object.entries(l))
            t[`elementStyles.${r}.${c}`] = s;
    } else
      t[o] = a;
  return t;
}, ir = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y
  } = Z(
    t,
    { ...pn, ...e },
    bo
    // Only use base fields for type transformations
  ), b = (R, I) => {
    if (R.includes(".")) {
      const W = xn(r, R, I), C = R.split(".")[0];
      s(C, W[C]);
    } else
      s(R, I);
  }, u = ae(() => kn(r), [r]), S = r.fontFamily, p = S && S !== "inherit" ? g[S] : null, k = p && p.format === "google" ? p.url : null, v = ae(() => {
    const R = [];
    if (r.elementStyles) {
      for (const I of Object.values(r.elementStyles))
        if (I != null && I.fontFamily && I.fontFamily !== "inherit") {
          const W = g[I.fontFamily];
          (W == null ? void 0 : W.format) === "google" && W.url && !R.includes(W.url) && R.push(W.url);
        }
    }
    return R;
  }, [r.elementStyles, g]);
  Q(() => {
    k && zt(k);
    for (const R of v)
      zt(R);
  }, [k, v]);
  const z = `message-bubble-${t || "default"}`, F = ae(
    () => fn(z, r.elementStyles, g),
    [z, r.elementStyles, g]
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const T = p ? p.format === "system" ? p.url : `"${p.name}", sans-serif` : "inherit", M = [`
    ${p && p.format !== "system" && p.format !== "google" ? `
      @font-face {
        font-family: "${p.name}";
        src: url("${p.url}") format("${p.format}");
        font-display: swap;
      }
    ` : ""}
    ${T !== "inherit" ? `.${z} { font-family: ${T} !important; }` : ""}
  `.trim(), F].filter(Boolean).join(`

`), x = {
    ...r,
    fontFamilyCss: T
  }, O = /* @__PURE__ */ h("div", { className: z, children: [
    M && /* @__PURE__ */ n("style", { children: M }),
    a(x)
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: bn,
      editValues: u,
      onEditChange: b,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: O
    }
  );
}, lr = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, Cn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, vn = {
  // Carousel properties
  carouselGap: 15,
  itemWidth: 240,
  itemWidthMobile: 180,
  // Card container
  cardBorderColor: "#dcdddc",
  cardBorderRadius: 12,
  cardBgColor: "#ffffff00",
  cardBgColorHover: "#F6F8FA",
  cardPadding: 16,
  cardPaddingMobile: 10,
  // Title
  titleColor: "#181D56",
  titleFontFamily: "inherit",
  titleFontSize: 14,
  titleFontWeight: 500,
  titleLineClamp: 3,
  titleLineHeight: 1.5,
  titleMarginTop: 20,
  // Price
  priceColor: "#181D56",
  priceFontFamily: "inherit",
  priceFontSize: 20,
  priceFontSizeMobile: 16,
  priceFontWeight: 600,
  // Retailer icons
  retailerIconSize: 25,
  retailerIconSizeMobile: 15,
  // Image container
  imageMaxWidth: 190
}, Tt = [
  // Carousel properties
  {
    key: "carouselGap",
    label: "Gap Between Items (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 1,
    group: "Carousel"
  },
  {
    key: "itemWidth",
    label: "Item Width (Desktop)",
    type: "number",
    min: 150,
    max: 300,
    step: 10,
    group: "Carousel"
  },
  {
    key: "itemWidthMobile",
    label: "Item Width (Mobile)",
    type: "number",
    min: 120,
    max: 220,
    step: 10,
    group: "Carousel"
  },
  // Card container
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBgColorHover",
    label: "Card Hover Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardPadding",
    label: "Card Padding (Desktop)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingMobile",
    label: "Card Padding (Mobile)",
    type: "number",
    min: 4,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color", group: "Title" },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font",
    group: "Title"
  },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: ue,
    group: "Title"
  },
  {
    key: "titleLineClamp",
    label: "Title Line Clamp",
    type: "number",
    min: 1,
    max: 5,
    step: 1,
    group: "Title"
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1,
    group: "Title"
  },
  {
    key: "titleMarginTop",
    label: "Title Margin Top (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Title"
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color", group: "Price" },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font",
    group: "Price"
  },
  {
    key: "priceFontSize",
    label: "Price Font Size (Desktop)",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontSizeMobile",
    label: "Price Font Size (Mobile)",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: on,
    group: "Price"
  },
  // Retailer icons
  {
    key: "retailerIconSize",
    label: "Retailer Icon Size (Desktop)",
    type: "number",
    min: 16,
    max: 40,
    step: 1,
    group: "Retailer Icons"
  },
  {
    key: "retailerIconSizeMobile",
    label: "Retailer Icon Size (Mobile)",
    type: "number",
    min: 12,
    max: 30,
    step: 1,
    group: "Retailer Icons"
  },
  // Image
  {
    key: "imageMaxWidth",
    label: "Image Max Width (px)",
    type: "number",
    min: 120,
    max: 250,
    step: 10,
    group: "Image"
  }
], wn = (e) => ({
  cardBorderColor: e.cardBorderColor,
  cardBorderRadius: e.cardBorderRadius,
  cardBgColor: e.cardBgColor,
  cardBgColorHover: e.cardBgColorHover,
  cardPadding: e.cardPadding,
  cardPaddingMobile: e.cardPaddingMobile,
  titleColor: e.titleColor,
  titleFontFamily: e.titleFontFamily,
  titleFontSize: e.titleFontSize,
  titleFontWeight: e.titleFontWeight,
  titleLineClamp: e.titleLineClamp,
  titleLineHeight: e.titleLineHeight,
  titleMarginTop: e.titleMarginTop,
  priceColor: e.priceColor,
  priceFontFamily: e.priceFontFamily,
  priceFontSize: e.priceFontSize,
  priceFontSizeMobile: e.priceFontSizeMobile,
  priceFontWeight: e.priceFontWeight,
  retailerIconSize: e.retailerIconSize,
  retailerIconSizeMobile: e.retailerIconSizeMobile,
  imageMaxWidth: e.imageMaxWidth
}), Sn = (e) => ({
  carouselGap: e.carouselGap,
  itemWidth: e.itemWidth,
  itemWidthMobile: e.itemWidthMobile
}), sr = ({ initialState: e = {}, widgetId: t, displayName: o, children: a }) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y,
    getEditValues: b
  } = Z(
    t,
    { ...vn, ...e },
    Tt
  ), u = r.titleFontFamily, S = u && u !== "inherit" ? g[u] : null, p = S && S.format === "google" ? S.url : null, k = r.priceFontFamily, v = k && k !== "inherit" ? g[k] : null, z = v && v.format === "google" ? v.url : null, F = ae(() => {
    const M = [];
    return p && !M.includes(p) && M.push(p), z && !M.includes(z) && M.push(z), M;
  }, [p, z]);
  if (Q(() => {
    for (const M of F)
      Cn(M);
  }, [F]), l)
    return /* @__PURE__ */ n(j, {});
  const T = wn(r), D = Sn(r), H = a(T, D, g);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Tt,
      editValues: b(),
      onEditChange: s,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: H
    }
  );
}, Bn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Fn = {
  // Background
  backgroundColor: "transparent",
  // Title styling
  titleColor: "#181d56",
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: "#181d56",
  iconColorHover: "#333333",
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: "#f3f4f6",
  // Badge styling (cart count)
  badgeBgColor: "#181d56",
  badgeTextColor: "#ffffff",
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, It = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...X],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], cr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y
  } = Z(
    t,
    { ...Fn, ...e },
    It
  ), b = r.titleFontFamily, u = b && b !== "inherit" ? g[b] : null, S = u && u.format === "google" ? u.url : null;
  if (Q(() => {
    S && Bn(S);
  }, [S]), l)
    return /* @__PURE__ */ n(j, {});
  const p = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", k = u && u.format !== "system" && u.format !== "google", v = `header-${t || "default"}`, z = `
    ${k ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${p !== "inherit" ? `.${v} [data-title-text] { font-family: ${p} !important; }` : ""}
  `.trim(), F = {
    ...r,
    titleFontFamilyCss: p
  }, T = /* @__PURE__ */ h(j, { children: [
    z && /* @__PURE__ */ n("style", { children: z }),
    a(F)
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: It,
      editValues: r,
      onEditChange: s,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: T
    }
  );
}, En = {
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors
  backgroundColor: "#1e293b",
  backgroundColorHover: "#334155",
  iconColor: "#ffffff",
  // Shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow
  shadowColor: "#181d56",
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200
}, Pt = [
  // Position
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ]
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4
  },
  // Size
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4
  },
  // Colors
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Shape
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Shadow
  { key: "shadowColor", label: "Shadow Color", type: "color" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], zn = (e) => {
  const { position: t, horizontalOffset: o, verticalOffset: a, size: r } = e, l = {
    position: "fixed",
    zIndex: 2147483647
    // Max z-index to ensure it's on top
  };
  return t.startsWith("bottom") ? l.bottom = a + r - 8 : l.top = a - 8, t.endsWith("left") ? l.left = o + r - 8 : l.right = o - 8, l;
}, dr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const [r, l] = P(!1), [c, s] = P({ x: 0, y: 0 }), [d, m] = P(null), [g, y] = P(!1), [b, u] = P(!1), S = q(null), p = uo(), {
    state: k,
    isLoading: v,
    isSaving: z,
    handleEditChange: F,
    handleSave: T,
    themeColors: D,
    canSave: H
  } = Z(
    t,
    { ...En, ...e },
    Pt
  ), M = se(() => d ? JSON.stringify(k) !== JSON.stringify(d) : !1, [k, d]);
  if (Q(() => t ? yo((B) => {
    B !== t && r && (M() ? y(!0) : l(!1));
  }) : void 0, [t, r, M]), v)
    return /* @__PURE__ */ n(j, {});
  const x = a(k);
  if (!p)
    return /* @__PURE__ */ n(j, { children: x });
  const O = () => {
    if (S.current) {
      const E = S.current.getBoundingClientRect(), B = window.innerWidth, N = window.innerHeight, w = 620, A = 450, L = 10, $ = N - E.bottom, G = E.top, _ = B - E.left, Y = E.right;
      let te;
      $ >= A + L ? te = E.bottom + L : G >= A + L ? te = E.top - A - L : $ >= G ? te = Math.max(L, N - A - L) : te = Math.max(L, E.top - A - L);
      let ne;
      _ >= w ? ne = E.left : Y >= w ? ne = E.right - w : ne = Math.max(
        L,
        Math.min(B - w - L, E.left)
      ), ne = Math.max(L, Math.min(ne, B - w - L)), te = Math.max(L, Math.min(te, N - A - L)), s({ x: ne, y: te });
    }
    m({ ...k }), l(!0), t && ho(t);
  }, R = () => {
    d && Object.keys(d).forEach((E) => {
      F(E, d[E]);
    });
  }, I = () => {
    T && H && T(), m({ ...k });
  }, W = () => {
    y(!1), l(!1);
  }, C = () => {
    I(), y(!1), l(!1);
  };
  return /* @__PURE__ */ h(j, { children: [
    /* @__PURE__ */ n("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${i.white};
          border: 1px solid ${i.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${i.blue_light};
          border-color: ${i.blue};
        }
      ` }),
    /* @__PURE__ */ h(
      "div",
      {
        onMouseEnter: () => u(!0),
        onMouseLeave: () => u(!1),
        style: { display: "contents" },
        children: [
          x,
          /* @__PURE__ */ n(
            "button",
            {
              ref: S,
              className: `floating-button-edit-icon ${b || r ? "visible" : ""}`,
              style: zn(k),
              onClick: (E) => {
                E.stopPropagation(), E.preventDefault(), O();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ n(Vt, { size: 16, color: i.gray_dark })
            }
          )
        ]
      }
    ),
    r && /* @__PURE__ */ n(
      go,
      {
        widgetId: t,
        displayName: o,
        fields: Pt,
        values: k,
        initialValues: d || void 0,
        onChange: F,
        onClose: () => l(!1),
        onReset: R,
        screenPosition: c,
        onSave: I,
        isSaving: z,
        themeColors: D
      }
    ),
    g && /* @__PURE__ */ n(
      fe,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: C,
        onCancel: W,
        isLoading: z
      }
    )
  ] });
}, Tn = {
  // Container
  containerBgColor: "#e9ecef",
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: "#999999",
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: "#666666",
  statusFontSize: 12,
  statusMarginTop: 8
}, At = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], pr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...Tn, ...e },
    At
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: At,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, In = {
  // Container
  backgroundColor: "#ffffff",
  borderColor: "#181d56",
  borderWidth: 1,
  borderRadius: 9999,
  // pill shape
  paddingX: 12,
  paddingY: 8,
  // Text
  textColor: "#181d56",
  textColorLoading: "rgba(0, 0, 0, 0.4)",
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  // Product images
  imageSize: 24,
  imageBorderColor: "#e5e7eb",
  imageOverlap: 12,
  imageBorderRadius: 9999,
  // circle
  // Counter (+N)
  counterTextColor: "rgba(0, 0, 0, 0.5)",
  counterFontSize: 14,
  // Placeholder (loading state)
  placeholderBgColor: "#f3f4f6"
}, Mt = [
  // Container
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Text
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "textColorLoading", label: "Text Color (Loading)", type: "color" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: X
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  // Product images
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  { key: "imageBorderColor", label: "Image Border Color", type: "color" },
  {
    key: "imageOverlap",
    label: "Image Overlap",
    type: "number",
    min: 0,
    max: 20,
    step: 2
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 2
  },
  // Counter
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Placeholder
  { key: "placeholderBgColor", label: "Placeholder Background", type: "color" }
], mr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    themeIcons: y,
    canSave: b
  } = Z(
    t,
    { ...In, ...e },
    Mt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const u = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Mt,
      editValues: r,
      onEditChange: s,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      themeIcons: y,
      children: u
    }
  );
}, Pn = {
  // Container
  containerBgColor: "#ffffff",
  containerGap: 8,
  // Image carousel
  imageBgColor: "#f7f7f7",
  imagePadding: 16,
  carouselArrowSize: 28,
  carouselArrowBgColor: "rgba(255, 255, 255, 0.9)",
  // Title
  titleColor: "#181d56",
  titleFontSize: 16,
  titleFontWeight: "semibold",
  titleLetterSpacing: 0.08,
  // Rating
  ratingStarColor: "#ED792F",
  ratingTextColor: "#181d56",
  ratingFontSize: 14,
  // Price
  priceColor: "#181d56",
  priceFontSize: 24,
  priceFontWeight: "semibold",
  priceLetterSpacing: 0.24,
  // Feature bullets
  featureTitleColor: "#181d56",
  featureTitleFontSize: 16,
  featureBulletColor: "#181d56",
  featureBulletFontSize: 12,
  // Primary CTA button
  primaryButtonBgColor: "#181d56",
  primaryButtonTextColor: "#ffffff",
  primaryButtonBorderRadius: 9999,
  primaryButtonHeight: 46,
  primaryButtonFontSize: 16,
  primaryButtonFontWeight: "semibold",
  // Secondary CTA button
  secondaryButtonBorderColor: "#181d56",
  secondaryButtonTextColor: "#181d56",
  secondaryButtonBorderRadius: 9999,
  secondaryButtonHeight: 46,
  secondaryButtonFontSize: 16,
  secondaryButtonFontWeight: "semibold",
  // Content section
  contentPadding: 16,
  contentGap: 16
}, Nt = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 24,
    step: 4
  },
  // Image carousel
  { key: "imageBgColor", label: "Image Background", type: "color" },
  {
    key: "imagePadding",
    label: "Image Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "carouselArrowSize",
    label: "Carousel Arrow Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "carouselArrowBgColor",
    label: "Carousel Arrow Background",
    type: "color"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...X]
  },
  // Rating
  { key: "ratingStarColor", label: "Rating Star Color", type: "color" },
  { key: "ratingTextColor", label: "Rating Text Color", type: "color" },
  {
    key: "ratingFontSize",
    label: "Rating Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 18,
    max: 36,
    step: 2
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...X]
  },
  // Feature bullets
  { key: "featureTitleColor", label: "Features Title Color", type: "color" },
  {
    key: "featureTitleFontSize",
    label: "Features Title Size",
    type: "number",
    min: 14,
    max: 20,
    step: 1
  },
  { key: "featureBulletColor", label: "Feature Bullet Color", type: "color" },
  {
    key: "featureBulletFontSize",
    label: "Feature Bullet Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Primary CTA button
  {
    key: "primaryButtonBgColor",
    label: "Primary Button Background",
    type: "color"
  },
  {
    key: "primaryButtonTextColor",
    label: "Primary Button Text",
    type: "color"
  },
  {
    key: "primaryButtonBorderRadius",
    label: "Primary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "primaryButtonHeight",
    label: "Primary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "primaryButtonFontSize",
    label: "Primary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Secondary CTA button
  {
    key: "secondaryButtonBorderColor",
    label: "Secondary Button Border",
    type: "color"
  },
  {
    key: "secondaryButtonTextColor",
    label: "Secondary Button Text",
    type: "color"
  },
  {
    key: "secondaryButtonBorderRadius",
    label: "Secondary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "secondaryButtonHeight",
    label: "Secondary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "secondaryButtonFontSize",
    label: "Secondary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Content section
  {
    key: "contentPadding",
    label: "Content Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "contentGap",
    label: "Content Gap",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  }
], gr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...Pn, ...e },
    Nt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Nt,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, An = {
  // Container
  containerGap: 8,
  containerMarginTop: 8,
  // Add to Bag button (primary state)
  addButtonBgColor: "#181d56",
  addButtonTextColor: "#ffffff",
  addButtonHeight: 40,
  addButtonHeightMobile: 36,
  addButtonFontSize: 14,
  addButtonFontSizeMobile: 12,
  addButtonBorderRadius: 8,
  // Added to Bag button (success state)
  addedButtonBorderColor: "#6b7280",
  addedButtonBorderColorHover: "#4b5563",
  addedButtonTextColor: "#6b7280",
  addedButtonBgColorHover: "#f9fafb",
  addedIconColor: "#6b7280",
  addedIconSize: 16,
  // Loading state
  loadingSpinnerColor: "#ffffff",
  loadingSpinnerSize: 14
}, Ht = [
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Add to Bag button
  { key: "addButtonBgColor", label: "Add Button Background", type: "color" },
  { key: "addButtonTextColor", label: "Add Button Text", type: "color" },
  {
    key: "addButtonHeight",
    label: "Add Button Height",
    type: "number",
    min: 32,
    max: 56,
    step: 2
  },
  {
    key: "addButtonHeightMobile",
    label: "Add Button Height (Mobile)",
    type: "number",
    min: 28,
    max: 48,
    step: 2
  },
  {
    key: "addButtonFontSize",
    label: "Add Button Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "addButtonFontSizeMobile",
    label: "Add Button Font Size (Mobile)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "addButtonBorderRadius",
    label: "Add Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Added to Bag button
  {
    key: "addedButtonBorderColor",
    label: "Added Button Border",
    type: "color"
  },
  {
    key: "addedButtonBorderColorHover",
    label: "Added Button Border (Hover)",
    type: "color"
  },
  { key: "addedButtonTextColor", label: "Added Button Text", type: "color" },
  {
    key: "addedButtonBgColorHover",
    label: "Added Button Bg (Hover)",
    type: "color"
  },
  { key: "addedIconColor", label: "Added Icon Color", type: "color" },
  {
    key: "addedIconSize",
    label: "Added Icon Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Loading state
  { key: "loadingSpinnerColor", label: "Loading Spinner Color", type: "color" },
  {
    key: "loadingSpinnerSize",
    label: "Loading Spinner Size",
    type: "number",
    min: 10,
    max: 24,
    step: 2
  }
], ur = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...An, ...e },
    Ht
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Ht,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, Ot = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Mn = {
  // Card/Pill container
  borderColor: "#DCDCDC",
  borderColorSelected: "#181d56",
  backgroundColor: "#ffffff",
  backgroundColorHover: "#F6F8FA",
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: "#181d56",
  checkmarkIconColor: "#ffffff",
  checkmarkSize: 16,
  // Price text
  priceColor: "#181d56",
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: "#181d56",
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: "#DCDCDC",
  dividerColorSelected: "#181d56"
}, Dt = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...X]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...X]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...X]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...X]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], hr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y
  } = Z(
    t,
    { ...Mn, ...e },
    Dt
  ), b = r.priceFontFamily, u = b && b !== "inherit" ? g[b] : null, S = r.nameFontFamily, p = S && S !== "inherit" ? g[S] : null, k = u && u.format === "google" ? u.url : null, v = p && p.format === "google" ? p.url : null;
  if (Q(() => {
    k && Ot(k);
  }, [k]), Q(() => {
    v && Ot(v);
  }, [v]), l)
    return /* @__PURE__ */ n(j, {});
  const z = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", F = p ? p.format === "system" ? p.url : `"${p.name}", sans-serif` : "inherit", T = u && u.format !== "system" && u.format !== "google", D = p && p.format !== "system" && p.format !== "google", H = `variant-picker-${t || "default"}`, M = `
    ${T ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${D ? `
      @font-face {
        font-family: "${p.name}";
        src: url("${p.url}") format("${p.format}");
        font-display: swap;
      }
    ` : ""}
    ${z !== "inherit" ? `.${H} [data-price-text] { font-family: ${z} !important; }` : ""}
    ${F !== "inherit" ? `.${H} [data-name-text] { font-family: ${F} !important; }` : ""}
  `.trim(), x = {
    ...r,
    priceFontFamilyCss: z,
    nameFontFamilyCss: F
  }, O = /* @__PURE__ */ h(j, { children: [
    M && /* @__PURE__ */ n("style", { children: M }),
    a(x)
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Dt,
      editValues: r,
      onEditChange: s,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: O
    }
  );
}, Rt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Nn = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: "rgba(236, 121, 46, 0.3)",
  instantTextColor: "rgb(236, 121, 46)",
  // Purchase reward - magenta
  purchaseBgColor: "rgba(162, 34, 114, 0.3)",
  purchaseTextColor: "rgb(162, 34, 114)",
  // Affiliate reward - teal
  affiliateBgColor: "rgba(22, 148, 155, 0.2)",
  affiliateTextColor: "rgb(22, 148, 155)",
  // Content/Survey reward - magenta
  contentBgColor: "rgba(162, 34, 114, 0.3)",
  contentTextColor: "rgb(162, 34, 114)",
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: "#181d56",
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, jt = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...X]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...X]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], yr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y
  } = Z(
    t,
    { ...Nn, ...e },
    jt
  ), b = r.pillFontFamily, u = b && b !== "inherit" ? g[b] : null, S = r.subfixFontFamily, p = S && S !== "inherit" ? g[S] : null, k = u && u.format === "google" ? u.url : null, v = p && p.format === "google" ? p.url : null;
  if (Q(() => {
    k && Rt(k);
  }, [k]), Q(() => {
    v && Rt(v);
  }, [v]), l)
    return /* @__PURE__ */ n(j, {});
  const z = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", F = p ? p.format === "system" ? p.url : `"${p.name}", sans-serif` : "inherit", T = u && u.format !== "system" && u.format !== "google", D = p && p.format !== "system" && p.format !== "google", H = `reward-pill-${t || "default"}`, M = `
    ${T ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${D ? `
      @font-face {
        font-family: "${p.name}";
        src: url("${p.url}") format("${p.format}");
        font-display: swap;
      }
    ` : ""}
    ${z !== "inherit" ? `.${H} [data-pill-text] { font-family: ${z} !important; }` : ""}
    ${F !== "inherit" ? `.${H} [data-subfix-text] { font-family: ${F} !important; }` : ""}
  `.trim(), x = {
    ...r,
    pillFontFamilyCss: z,
    subfixFontFamilyCss: F
  }, O = /* @__PURE__ */ h(j, { children: [
    M && /* @__PURE__ */ n("style", { children: M }),
    a(x)
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: jt,
      editValues: r,
      onEditChange: s,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: O
    }
  );
}, Hn = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: "#181d56",
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, Wt = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...X]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], br = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...Hn, ...e },
    Wt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Wt,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, On = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: "#f6f8fa",
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: "#181d56",
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: "#181d56",
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: "#181d56",
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: "#181d56",
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: "#e5e7eb",
  suggestionPillBgColor: "transparent",
  suggestionPillBgColorHover: "#f3f4f6",
  suggestionPillTextColor: "#181d56",
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Lt = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...X]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...X]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], fr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...On, ...e },
    Lt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Lt,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, Dn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Rn = {
  // Container
  containerGap: 8,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: "#e5e7eb",
  pillBorderWidth: 1,
  pillBgColor: "transparent",
  pillBgColorHover: "#f3f4f6",
  pillTextColor: "#181d56",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Qt = [
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...X]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], xr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y
  } = Z(
    t,
    { ...Rn, ...e },
    Qt
  ), b = r.pillFontFamily, u = b && b !== "inherit" ? g[b] : null, S = u && u.format === "google" ? u.url : null;
  if (Q(() => {
    S && Dn(S);
  }, [S]), l)
    return /* @__PURE__ */ n(j, {});
  const p = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", k = u && u.format !== "system" && u.format !== "google", v = `suggestion-list-${t || "default"}`, z = `
    ${k ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${p !== "inherit" ? `.${v} { font-family: ${p} !important; }` : ""}
  `.trim(), F = {
    ...r,
    pillFontFamilyCss: p
  }, T = /* @__PURE__ */ h(j, { children: [
    z && /* @__PURE__ */ n("style", { children: z }),
    /* @__PURE__ */ n("div", { className: v, children: a(F) })
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Qt,
      editValues: r,
      onEditChange: s,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: T
    }
  );
}, jn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Wn = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: "rgba(255, 255, 255, 0.6)",
  pillBorderColor: "#ffffff",
  pillTextColor: "#031425",
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: "rgba(255, 255, 255, 0.6)",
  arrowBorderColor: "#ffffff",
  arrowIconColor: "#031425",
  // Title
  titleColor: "#031425",
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, Gt = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...X]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], kr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    canSave: y,
    getEditValues: b
  } = Z(
    t,
    { ...Wn, ...e },
    Gt
  ), u = r.titleFontFamily, S = u && u !== "inherit" ? g[u] : null, p = S && S.format === "google" ? S.url : null;
  if (Q(() => {
    p && jn(p);
  }, [p]), l)
    return /* @__PURE__ */ n(j, {});
  const k = S ? S.format === "system" ? S.url : `"${S.name}", sans-serif` : "inherit", v = S && S.format !== "system" && S.format !== "google", z = `trending-card-${t || "default"}`, F = `
    ${v ? `
      @font-face {
        font-family: "${S.name}";
        src: url("${S.url}") format("${S.format}");
        font-display: swap;
      }
    ` : ""}
    ${k !== "inherit" ? `.${z} [data-title-text] { font-family: ${k} !important; }` : ""}
  `.trim(), T = {
    ...r,
    titleFontFamilyCss: k
  }, D = /* @__PURE__ */ h(j, { children: [
    F && /* @__PURE__ */ n("style", { children: F }),
    a(T)
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Gt,
      editValues: b(),
      onEditChange: s,
      onSave: y ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      children: D
    }
  );
}, Ln = {
  // Drawer container
  drawerWidth: 320,
  drawerBgColor: "#ffffff",
  // Header
  headerPaddingX: 12,
  headerPaddingY: 12,
  headerTitleFontSize: 14,
  headerTitleFontWeight: "semibold",
  headerTitleColor: "#181d56",
  headerIconColor: "#6b7280",
  headerIconColorHover: "#111827",
  headerIconBgColorHover: "#f3f4f6",
  // List items
  itemPaddingX: 12,
  itemPaddingY: 10,
  itemBgColor: "transparent",
  itemBgColorHover: "#f9fafb",
  itemTitleFontSize: 14,
  itemTitleFontWeight: "medium",
  itemTitleColor: "#111827",
  itemTitleLineClamp: 2,
  // Timestamp
  showTimestamp: !1,
  timestampFontSize: 12,
  timestampColor: "#6b7280",
  timestampMarginTop: 4,
  // Empty state
  emptyStateFontSize: 14,
  emptyStateColor: "#6b7280",
  emptyStatePadding: 24,
  // Error state
  errorBgColor: "#fef2f2",
  errorTextColor: "#991b1b",
  errorFontSize: 14,
  errorPadding: 12,
  errorBorderRadius: 8
}, Jt = [
  // Drawer container
  {
    key: "drawerWidth",
    label: "Drawer Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  { key: "drawerBgColor", label: "Drawer Background", type: "color" },
  // Header
  {
    key: "headerPaddingX",
    label: "Header Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "headerPaddingY",
    label: "Header Padding Y",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "headerTitleFontSize",
    label: "Header Title Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "headerTitleFontWeight",
    label: "Header Title Weight",
    type: "options",
    options: [...X]
  },
  { key: "headerTitleColor", label: "Header Title Color", type: "color" },
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  { key: "headerIconColorHover", label: "Header Icon Hover", type: "color" },
  {
    key: "headerIconBgColorHover",
    label: "Header Icon Bg Hover",
    type: "color"
  },
  // List items
  {
    key: "itemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "itemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  { key: "itemBgColor", label: "Item Background", type: "color" },
  { key: "itemBgColorHover", label: "Item Background (Hover)", type: "color" },
  {
    key: "itemTitleFontSize",
    label: "Item Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "itemTitleFontWeight",
    label: "Item Title Weight",
    type: "options",
    options: [...X]
  },
  { key: "itemTitleColor", label: "Item Title Color", type: "color" },
  {
    key: "itemTitleLineClamp",
    label: "Item Title Line Clamp",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Timestamp
  { key: "showTimestamp", label: "Show Timestamp", type: "toggle" },
  {
    key: "timestampFontSize",
    label: "Timestamp Font Size",
    type: "number",
    min: 10,
    max: 14,
    step: 1
  },
  { key: "timestampColor", label: "Timestamp Color", type: "color" },
  {
    key: "timestampMarginTop",
    label: "Timestamp Margin Top",
    type: "number",
    min: 0,
    max: 12,
    step: 2
  },
  // Empty state
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 16,
    step: 1
  },
  { key: "emptyStateColor", label: "Empty State Color", type: "color" },
  {
    key: "emptyStatePadding",
    label: "Empty State Padding",
    type: "number",
    min: 12,
    max: 48,
    step: 4
  },
  // Error state
  { key: "errorBgColor", label: "Error Background", type: "color" },
  { key: "errorTextColor", label: "Error Text Color", type: "color" },
  {
    key: "errorFontSize",
    label: "Error Font Size",
    type: "number",
    min: 12,
    max: 16,
    step: 1
  },
  {
    key: "errorPadding",
    label: "Error Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "errorBorderRadius",
    label: "Error Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  }
], Qn = ({ initialState: e = {}, widgetId: t, displayName: o, children: a }) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...Ln, ...e },
    Jt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Jt,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, Gn = {
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#DCDDDC",
  cardBorderRadius: 8,
  cardShadowColor: "#181d56",
  cardShadowOpacity: 0.08,
  cardPadding: 12,
  // Retailer logo
  logoContainerSize: 40,
  logoContainerBgColor: "#F6F8FA",
  logoContainerBorderRadius: 50,
  // Card text
  cardTitleFontSize: 14,
  cardTitleFontWeight: "semibold",
  cardTitleColor: "#181d56",
  cardSubtitleFontSize: 12,
  cardSubtitleColor: "rgba(0, 0, 0, 0.7)",
  // Card button
  cardButtonBgColor: "#F6F8FA",
  cardButtonTextColor: "#181d56",
  cardButtonFontSize: 12,
  cardButtonBorderRadius: 18,
  cardButtonPaddingX: 14,
  cardButtonPaddingY: 4,
  // Search bar
  searchBgColor: "#ffffff",
  searchBorderColor: "#DCDDDC",
  searchBorderRadius: 100,
  searchHeight: 44,
  searchPlaceholderColor: "rgba(0, 0, 0, 0.5)",
  searchTextColor: "#181d56",
  searchIconColor: "rgba(0, 0, 0, 0.6)",
  // Detail panel
  panelBgColor: "#ffffff",
  panelWidth: 300,
  panelBorderRadius: 10,
  panelImageHeight: 164,
  // Status colors
  statusOpenColor: "#71c184",
  statusClosedColor: "#ef4444",
  // Section titles
  sectionTitleFontSize: 12,
  sectionTitleFontWeight: "bold",
  sectionTitleColor: "#181d56",
  // Loading/empty states
  loadingBgColor: "#F6F8FA",
  emptyStateTextColor: "#666666",
  emptyStateFontSize: 14
}, Yt = [
  // Card styling
  { key: "cardBgColor", label: "Card Background", type: "color" },
  { key: "cardBorderColor", label: "Card Border Color", type: "color" },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  { key: "cardShadowColor", label: "Card Shadow Color", type: "color" },
  {
    key: "cardShadowOpacity",
    label: "Card Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Retailer logo
  {
    key: "logoContainerSize",
    label: "Logo Container Size",
    type: "number",
    min: 24,
    max: 56,
    step: 4
  },
  {
    key: "logoContainerBgColor",
    label: "Logo Container Background",
    type: "color"
  },
  {
    key: "logoContainerBorderRadius",
    label: "Logo Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Card text
  {
    key: "cardTitleFontSize",
    label: "Card Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "cardTitleFontWeight",
    label: "Card Title Weight",
    type: "options",
    options: [...X]
  },
  { key: "cardTitleColor", label: "Card Title Color", type: "color" },
  {
    key: "cardSubtitleFontSize",
    label: "Card Subtitle Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  { key: "cardSubtitleColor", label: "Card Subtitle Color", type: "color" },
  // Card button
  { key: "cardButtonBgColor", label: "Card Button Background", type: "color" },
  { key: "cardButtonTextColor", label: "Card Button Text", type: "color" },
  {
    key: "cardButtonFontSize",
    label: "Card Button Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "cardButtonBorderRadius",
    label: "Card Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingX",
    label: "Card Button Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingY",
    label: "Card Button Padding Y",
    type: "number",
    min: 2,
    max: 12,
    step: 2
  },
  // Search bar
  { key: "searchBgColor", label: "Search Background", type: "color" },
  { key: "searchBorderColor", label: "Search Border Color", type: "color" },
  {
    key: "searchBorderRadius",
    label: "Search Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "searchHeight",
    label: "Search Height",
    type: "number",
    min: 36,
    max: 56,
    step: 2
  },
  {
    key: "searchPlaceholderColor",
    label: "Search Placeholder Color",
    type: "color"
  },
  { key: "searchTextColor", label: "Search Text Color", type: "color" },
  { key: "searchIconColor", label: "Search Icon Color", type: "color" },
  // Detail panel
  { key: "panelBgColor", label: "Panel Background", type: "color" },
  {
    key: "panelWidth",
    label: "Panel Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  {
    key: "panelBorderRadius",
    label: "Panel Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "panelImageHeight",
    label: "Panel Image Height",
    type: "number",
    min: 100,
    max: 240,
    step: 10
  },
  // Status colors
  { key: "statusOpenColor", label: "Status Open Color", type: "color" },
  { key: "statusClosedColor", label: "Status Closed Color", type: "color" },
  // Section titles
  {
    key: "sectionTitleFontSize",
    label: "Section Title Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "sectionTitleFontWeight",
    label: "Section Title Weight",
    type: "options",
    options: [...X]
  },
  { key: "sectionTitleColor", label: "Section Title Color", type: "color" },
  // Loading/empty states
  { key: "loadingBgColor", label: "Loading Background", type: "color" },
  { key: "emptyStateTextColor", label: "Empty State Text", type: "color" },
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  }
], Cr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    canSave: g
  } = Z(
    t,
    { ...Gn, ...e },
    Yt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const y = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Yt,
      editValues: r,
      onEditChange: s,
      onSave: g ? d : void 0,
      isSaving: c,
      themeColors: m,
      children: y
    }
  );
}, Jn = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: "rgba(0, 0, 0, 0.5)",
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: "rgba(0, 0, 0, 0.5)",
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: "rgba(0, 0, 0, 0.5)",
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: "#666666",
  thinkingTextFontSize: 14,
  thinkingBgColor: "#ffffff",
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: "#e0e0e0",
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, Xt = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: X
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], vr = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: a
}) => {
  const {
    state: r,
    isLoading: l,
    isSaving: c,
    handleEditChange: s,
    handleSave: d,
    themeColors: m,
    themeFonts: g,
    themeIcons: y,
    canSave: b
  } = Z(
    t,
    { ...Jn, ...e },
    Xt
  );
  if (l)
    return /* @__PURE__ */ n(j, {});
  const u = a(r);
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: t,
      displayName: o,
      editFields: Xt,
      editValues: r,
      onEditChange: s,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: m,
      themeFonts: g,
      themeIcons: y,
      children: u
    }
  );
}, Zt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Fe = ({ width: e }) => /* @__PURE__ */ n(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), Yn = {
  // Title
  showTitle: !0,
  titleText: "✨ Get expert advice on this product",
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: "#181d56",
  // Container
  containerGap: 16,
  containerMarginTop: 32,
  containerMarginBottom: 16,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: "#e5e7eb",
  pillBorderWidth: 1,
  pillBgColor: "transparent",
  pillBgColorHover: "#f3f4f6",
  pillTextColor: "#181d56",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Ut = [
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...X]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...X]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], fo = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Xn = ({ question: e, onClick: t, state: o }) => {
  const [a, r] = P(!1);
  return /* @__PURE__ */ n(
    "button",
    {
      onClick: t,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      style: {
        padding: `${o.pillPaddingY}px ${o.pillPaddingX}px`,
        borderRadius: `${o.pillBorderRadius}px`,
        border: `${o.pillBorderWidth}px solid ${o.pillBorderColor}`,
        backgroundColor: a ? o.pillBgColorHover : o.pillBgColor,
        color: o.pillTextColor,
        fontSize: `${o.pillFontSize}px`,
        fontWeight: fo[o.pillFontWeight] || 500,
        fontFamily: o.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: 1.4
      },
      children: e
    }
  );
}, wr = ({
  widgetId: e = "conversation-starters",
  displayName: t = "Conversation Starters",
  initialState: o = {},
  questions: a,
  isLoading: r = !1,
  onQuestionClick: l
}) => {
  const {
    state: c,
    isLoading: s,
    isSaving: d,
    handleEditChange: m,
    handleSave: g,
    themeColors: y,
    themeFonts: b,
    canSave: u
  } = Z(
    e,
    { ...Yn, ...o },
    Ut
  ), S = c.pillFontFamily, p = S && S !== "inherit" ? b[S] : null, k = c.titleFontFamily, v = k && k !== "inherit" ? b[k] : null, z = p && p.format === "google" ? p.url : null, F = v && v.format === "google" ? v.url : null;
  if (Q(() => {
    z && Zt(z);
  }, [z]), Q(() => {
    F && Zt(F);
  }, [F]), s || !r && a.length === 0)
    return null;
  const T = p ? p.format === "system" ? p.url : `"${p.name}", sans-serif` : "inherit", D = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", H = p && p.format !== "system" && p.format !== "google", M = v && v.format !== "system" && v.format !== "google", x = `conversation-starters-${e || "default"}`, O = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${H ? `
      @font-face {
        font-family: "${p.name}";
        src: url("${p.url}") format("${p.format}");
        font-display: swap;
      }
    ` : ""}
    ${M ? `
      @font-face {
        font-family: "${v.name}";
        src: url("${v.url}") format("${v.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), R = {
    ...c,
    pillFontFamilyCss: T,
    titleFontFamilyCss: D
  }, I = /* @__PURE__ */ h(j, { children: [
    O && /* @__PURE__ */ n("style", { children: O }),
    /* @__PURE__ */ h(
      "div",
      {
        className: x,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: `${c.containerGap}px`,
          marginTop: `${c.containerMarginTop}px`,
          marginBottom: `${c.containerMarginBottom}px`
        },
        children: [
          c.showTitle && /* @__PURE__ */ n(
            "h3",
            {
              style: {
                fontSize: `${c.titleFontSize}px`,
                fontWeight: fo[c.titleFontWeight] || 600,
                fontFamily: D,
                color: c.titleColor,
                margin: 0
              },
              children: c.titleText
            }
          ),
          r ? /* @__PURE__ */ h(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ n(Fe, { width: 180 }),
                /* @__PURE__ */ n(Fe, { width: 140 }),
                /* @__PURE__ */ n(Fe, { width: 200 }),
                /* @__PURE__ */ n(Fe, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ n(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: a.map((W, C) => /* @__PURE__ */ n(
                Xn,
                {
                  question: W,
                  onClick: () => l(W),
                  state: R
                },
                C
              ))
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ n(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: Ut,
      editValues: c,
      onEditChange: m,
      onSave: u ? g : void 0,
      isSaving: d,
      themeColors: y,
      themeFonts: b,
      children: I
    }
  );
}, xo = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Zn = (e) => {
  const t = new Date(e), a = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), r = Math.floor(a / (1e3 * 60 * 60 * 24));
  return r === 0 ? "Today" : r === 1 ? "Yesterday" : r < 7 ? `${r} days ago` : t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}, Un = ({
  conversation: e,
  isActive: t,
  onSelect: o,
  state: a
}) => {
  const [r, l] = P(!1);
  return /* @__PURE__ */ h(
    "button",
    {
      onClick: () => o(e.conversationId),
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      style: {
        width: "100%",
        textAlign: "left",
        padding: `${a.itemPaddingY}px ${a.itemPaddingX}px`,
        backgroundColor: t || r ? a.itemBgColorHover : a.itemBgColor,
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        borderRadius: "5px",
        display: "block"
      },
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            style: {
              fontSize: `${a.itemTitleFontSize}px`,
              fontWeight: xo(a.itemTitleFontWeight),
              color: a.itemTitleColor,
              lineHeight: "24px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: a.itemTitleLineClamp,
              WebkitBoxOrient: "vertical"
            },
            children: e.title || e.preview
          }
        ),
        a.showTimestamp && /* @__PURE__ */ n(
          "div",
          {
            style: {
              fontSize: `${a.timestampFontSize}px`,
              color: a.timestampColor,
              marginTop: `${a.timestampMarginTop}px`
            },
            children: Zn(e.lastUpdated)
          }
        )
      ]
    }
  );
}, Sr = ({
  conversations: e,
  isLoading: t = !1,
  error: o = null,
  onSelect: a,
  currentConversationId: r,
  widgetId: l = "conversation-history",
  displayName: c = "Conversation History",
  initialState: s = {},
  showHeader: d = !1,
  headerTitle: m = "Chat History",
  onClose: g,
  emptyMessage: y = "No conversations yet"
}) => /* @__PURE__ */ n(
  Qn,
  {
    widgetId: l,
    displayName: c,
    initialState: s,
    children: (b) => /* @__PURE__ */ h(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          backgroundColor: b.drawerBgColor
        },
        children: [
          d && /* @__PURE__ */ h(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: `${b.headerPaddingY}px ${b.headerPaddingX}px`,
                borderBottom: "1px solid #e5e7eb",
                flexShrink: 0
              },
              children: [
                /* @__PURE__ */ n(
                  "span",
                  {
                    style: {
                      fontSize: `${b.headerTitleFontSize}px`,
                      fontWeight: xo(b.headerTitleFontWeight),
                      color: b.headerTitleColor
                    },
                    children: m
                  }
                ),
                g && /* @__PURE__ */ n(
                  $n,
                  {
                    onClick: g,
                    color: b.headerIconColor,
                    hoverColor: b.headerIconColorHover,
                    hoverBgColor: b.headerIconBgColorHover
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              style: {
                flex: 1,
                overflowY: "auto",
                padding: `${b.itemPaddingY}px ${b.itemPaddingX}px`
              },
              children: [
                t && /* @__PURE__ */ n(
                  "div",
                  {
                    style: {
                      display: "flex",
                      justifyContent: "center",
                      padding: `${b.emptyStatePadding}px`
                    },
                    children: /* @__PURE__ */ n(qn, { color: b.emptyStateColor })
                  }
                ),
                !t && o && /* @__PURE__ */ n(
                  "div",
                  {
                    style: {
                      backgroundColor: b.errorBgColor,
                      color: b.errorTextColor,
                      fontSize: `${b.errorFontSize}px`,
                      padding: `${b.errorPadding}px`,
                      borderRadius: `${b.errorBorderRadius}px`
                    },
                    children: o
                  }
                ),
                !t && !o && e.length === 0 && /* @__PURE__ */ n(
                  "div",
                  {
                    style: {
                      textAlign: "center",
                      padding: `${b.emptyStatePadding}px`,
                      fontSize: `${b.emptyStateFontSize}px`,
                      color: b.emptyStateColor
                    },
                    children: y
                  }
                ),
                !t && !o && e.map((u) => /* @__PURE__ */ n(
                  Un,
                  {
                    conversation: u,
                    isActive: u.conversationId === r,
                    onSelect: a,
                    state: b
                  },
                  u.conversationId
                ))
              ]
            }
          )
        ]
      }
    )
  }
), $n = ({
  onClick: e,
  color: t,
  hoverColor: o,
  hoverBgColor: a
}) => {
  const [r, l] = P(!1);
  return /* @__PURE__ */ n(
    "button",
    {
      onClick: e,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      "aria-label": "Close",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "28px",
        height: "28px",
        borderRadius: "6px",
        border: "none",
        cursor: "pointer",
        backgroundColor: r ? a : "transparent",
        transition: "background-color 0.15s ease"
      },
      children: /* @__PURE__ */ h(
        "svg",
        {
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: r ? o : t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: [
            /* @__PURE__ */ n("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
            /* @__PURE__ */ n("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
          ]
        }
      )
    }
  );
}, qn = ({ color: e }) => /* @__PURE__ */ h(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      animation: "bc-history-spin 1s linear infinite"
    },
    children: [
      /* @__PURE__ */ n("style", { children: `
          @keyframes bc-history-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
      /* @__PURE__ */ n(
        "circle",
        {
          cx: "12",
          cy: "12",
          r: "10",
          stroke: e,
          strokeWidth: "3",
          strokeLinecap: "round",
          strokeDasharray: "32",
          strokeDashoffset: "12"
        }
      )
    ]
  }
);
export {
  J as Button,
  ur as BuyBoxWidget,
  vr as ChainOfThoughtWidget,
  nr as ChatInput,
  Qn as ConversationHistoryWidget,
  wr as ConversationStartersWidget,
  lr as ELEMENT_GROUPS,
  go as EditPanel,
  gr as FeaturedProductWidget,
  dr as FloatingButtonWidget,
  rr as FollowUpQueriesWidget,
  cr as HeaderWidget,
  Sr as HistoryList,
  ir as MessageBubbleWidget,
  sr as ProductCardCarouselWidget,
  br as RetailerIconWidget,
  yr as RewardPillWidget,
  mr as SearchQueryPillWidget,
  Cr as StoreLocatorWidget,
  xr as SuggestionListWidget,
  ar as TextBox,
  or as ThemeManager,
  kr as TrendingCardWidget,
  pr as TypingIndicatorWidget,
  hr as VariantPickerWidget,
  ze as WIDGET_THEME_QUERY_KEY,
  fr as WelcomeScreenWidget,
  U as WidgetWrapper,
  Fo as clearThemeParams,
  zo as clearUrlParams,
  i as colors,
  Bo as getThemeParams,
  So as saveThemeParams,
  Eo as syncUrlToStorage,
  tr as updateUrlParams,
  uo as useEditMode,
  oo as useThemeColors,
  ao as useThemeFonts,
  no as useThemeIcons,
  ba as useWidgetConfig,
  fa as useWidgetEdit,
  Z as useWidgetEditable,
  ke as useWidgetTheme,
  xe as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
